import React from 'react';
import '../template-file-css/document-file-template.css';


export const PD_IntakePacket = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='PD_IntakePacket' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <h3>Positive Direction Support Services</h3>
                </p>
                <p className='w-750'>
                    <h3>Intake Document Checklist</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDOB' name='txtDOB' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h4>Document packet must be returned to Front Office immediately following assessment.</h4>
                </p>
                <p className='w-750'>
                    <h4>PLEASE COMPLETE THIS ENTIRE PACKET IN BLUE INK ONLY</h4>
                </p>
                <p className='w-750'>
                    <b>Every page MUST have Recipient's Name on it.</b>
                </p>
                <table>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Check when completed</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Document #</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Name of Document</span> </td>
                        <td className='w-350'> <span className='eleHeader'>Signatures Needed</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_1' name='cbCheckWhenCompleted_1' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            1
                        </td>
                        <td className='w-200'>
                            Copy of Initial Contact Form (Patient Information)
                        </td>
                        <td className='w-350'>
                            Front Office Personnel completes form
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_2' name='cbCheckWhenCompleted_2' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            2
                        </td>
                        <td className='w-200'>
                            Freedom of Choice Form
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_3' name='cbCheckWhenCompleted_3' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            3
                        </td>
                        <td className='w-200'>
                            Annual MHR Orientation
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_4' name='cbCheckWhenCompleted_4' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            4
                        </td>
                        <td className='w-200'>
                            Notice of Privacy Practices and Rights of Person Served
                        </td>
                        <tr>
                            <td className='signature w-350'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-350'> Recipient/Guardian </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_5' name='cbCheckWhenCompleted_5' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            5
                        </td>
                        <td className='w-200'>
                            Responsibilities of Persons Served
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_6' name='cbCheckWhenCompleted_6' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            6
                        </td>
                        <td className='w-200'>
                            Informed Consent to Treatment/Limits of Confidentiality
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_7' name='cbCheckWhenCompleted_7' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            7
                        </td>
                        <td className='w-200'>
                            Child Abuse and/or Neglect
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_8' name='cbCheckWhenCompleted_8' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            8
                        </td>
                        <td className='w-200'>
                            Authorization to Release Information
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_9' name='cbCheckWhenCompleted_9' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            9
                        </td>
                        <td className='w-200'>
                            School Consent Form
                        </td>
                        <tr>
                            <td className='signature w-350'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-350'> Recipient/Guardian </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_10' name='cbCheckWhenCompleted_10' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            10
                        </td>
                        <td className='w-200'>
                            Emergency Contact
                        </td>
                        <tr>
                            <td className='signature w-350'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-350'> Recipient/Guardian </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_11' name='cbCheckWhenCompleted_11' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            11
                        </td>
                        <td className='w-200'>
                            Client Contract
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_12' name='cbCheckWhenCompleted_12' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            12
                        </td>
                        <td className='w-200'>
                            Discharge Policy
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckWhenCompleted_13' name='cbCheckWhenCompleted_13' className='add-only' value='CheckWhenCompleted' />
                        </td>
                        <td className='w-100'>
                            13
                        </td>
                        <td className='w-200'>
                            Client Acknowledgement
                        </td>
                        <tr>
                            <td className='signature w-175'>&nbsp; </td>
                            <td className='signature w-175'>&nbsp; </td>
                        </tr>
                    </tr>
                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='small w-175'> Recipient/Guardian </td>
                        <td className='small w-175'> LMHP </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <hr />  </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Write name on ALL pages of Intake Packet(confirm that Recipient/Guardian has completed all documents)
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h4>Annual MHR Client Orientation</h4>
                </p>
                <p className='w-750'>
                    <h4>You will be given a copy of/an explanation of the following information:</h4>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            1. Organization's Responsibilities
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            2. Freedom of Choice Statement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            3. Client's rights and responsibilities
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            4. Notice of Privacy Practices
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            5. Responsibilities of Persons Served
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            6. Limits of Confidentiality
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            7. Complaint procedures for client
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            8. Louisiana Child Abuse and/or Neglect
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            9. Client Acknowledgement form
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            10. Authorization to Release Information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            11. Parent School Release Letter
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            12. Discharge Policy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            13. Individualized Service Recovery Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            14. Teen Handout (Ages 12-19)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>I acknowledge that I have received all of the above information:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'> Client's Name (Print):</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtClientNamePrint' name='txtClientNamePrint' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDOBDateOfBirth' name='txtDOBDateOfBirth' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Guardian's Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>

                        <td className='small w-750'> Parent/Guardian's (Print): </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Member's Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>

                        <td className='small w-750'> Staff Member's (Print): </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services</h3>
                </p>
                <p className='w-750'>
                    <h4>Rights of the Persons Served and Notice of Privacy Practices</h4>
                </p>
                <p className='w-750'>
                    <h4>Rights of the Persons Served</h4>
                </p>
                <p className='w-750'>
                    <h5>Positive Direction Support Services believes that all clients and human beings have these rights:</h5>
                </p>
                <p className='w-750'>
                    <ol>
                        <li>To choose a provider of behavioral health services, from an approved list of providers         maintained by Magellan Health Services ('freedom of choice');</li>
                        <li>To be accepted for services only if this agency has the ability to provide services at the         level of intensity needed by the individual;</li>
                        <li>To be treated with dignity and respect as an individual who has personal needs,         feelings, preferences and requirements;</li>
                        <li>To privacy in treatment, in care, and in the fulfillment of personal needs;</li>
                        <li>To be fully informed of all available services and of charges for these services;</li>
                        <li>To be fully informed of all rights as a member and of all rules and regulations governing conduct as a member in this facility;</li>
                        <li>To manage personal financial affairs; thereby, if assistance is requested, this agency         will arrange appropriate assistance for the individual;</li>
                        <li>To participate in the development of an individual service plan;</li>
                        <li>To receive information necessary to give informed consent prior to the start of any         services and/or treatment;</li>
                        <li>To refuse treatment to the extent permitted by law and be informed of the         consequences of this right;</li>
                        <li>To the continuity of care which includes not being discharged or transferred except         for medical reasons, for the individual's personal</li>
                        <li>welfare, or for the welfare of others; therefore, should transfer or discharge become necessary, the member will be given reasonable advance notice, unless an emergency situation exists;</li>
                        <li>To voice opinion, recommendations and grievances in relation to policies, staff and services offered by the facility without fear of restraint, interference, coercion, discrimination, or reprisal;</li>
                        <li>To be free from:</li>
                        <ol type='a'>
                            <li>physical, chemical, or mental abuse;</li>
                            <li>financial or other exploitation;</li>
                            <li>retaliation;</li>
                            <li>humiliation; and/or</li>
                            <li>neglect;</li>
                        </ol>
                        <li>To confidential treatment of all personal and medical records, in accordance with the        agency's Notice of Privacy Practices;</li>
                        <li>To refuse to perform any service for the facility, or for other members, unless they are        a part of a therapeutic plan of treatment which the member has approved;</li>
                        <li>To all benefits and privileges guaranteed by Federal, State, and local law, except those        specifically lost through the due process of law;</li>
                        <li>To live in their community of choice without restraints on independence, except those         restraints to which all citizens are subject;</li>
                        <li>To receive services without discrimination based on race, color, sex, sexual orientation, age, religion, national origin, domestic/marital status, political affiliation or opinion, veteran's status, physical/mental handicap or ability to pay for services;</li>
                        <li>To access guardians, self-help groups, advocacy services and legal services at any time; access will be facilitated through an assigned community support worker; and,to be ensured of Informed Consent regarding:</li>
                        <ol type='a'>
                            <li>Service delivery;</li>
                            <li>Release of information;</li>
                            <li>Concurrent services;</li>
                            <li>Composition of the service delivery team; and,</li>
                            <li>Involvement in research projects, when applicable.</li>
                        </ol>
                        <li>If the individual being served is a minor or has a court-appointed guardian or other legal representative, all information outlined above will be provided to the guardian or legal representative, as well as to the individual served, for as long as the individual requires it.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <h3>Individual Rights Related to Privacy Practices (NPP)</h3>
                </p>
                <p className='w-750'>
                    <h4>Consistent with the provisions of the Privacy Rule, PDS assures the rights of individuals to:</h4>
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Have access to their health information;</li>
                        <li>Have written, meaningful notice regarding the ways in which their health information is used and disclosed;</li>
                        <li>Have an opportunity to request restrictions to the use and disclosure of their health         information, and to have reasonable requests honored;</li>
                        <li>Have an opportunity to request corrections or amendments to their health         information;</li>
                        <li>Receive, upon written request, an accounting of the disclosures made of their health         information;</li>
                        <li>File complaints regarding the organization's use or disclosure of private health information, and to be free from retaliation for having filed such a complaint or complaints; and</li>
                        <li>To further protect the privacy of individuals during service delivery:</li>
                        <ol type='a'>
                            <li>Services are delivered in areas that respect the privacy of the individual served;</li>
                            <li>Conversations with or about the individual served are conducted in such a             manner that others not involved in the case do not overhear; and,</li>
                            <li>The identity of individuals served or their families are not revealed during the transmission of information via e-mail, texting, blogging, or other social media such as Facebook or Twitter.</li>
                        </ol>
                    </ol>
                </p>
                <p className='w-750'>
                    <b>NOTICE: This entire document is reprinted in the Client    Handbook which every client receives.</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services</h3>
                </p>
                <p className='w-750'>
                    <h4>Responsibilities of Person Served</h4>
                </p>
                <p className='w-750'>
                    As a member, you have the responsibility to:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Meet with assigned workers on a regular basis at your home, in the community or other mutually agreed upon location</li>
                        <li>Attend all Psychiatry and Medical appointments</li>
                        <li>Participate in the services identified by yourself and your treatment team, including taking medication(s) as prescribed</li>
                        <li>Work together with your worker by sharing accurate information about your treatment and any problems/concerns you may have which interfere with your goals and treatment progress</li>
                        <li>Actively help your worker in planning your services and deciding what actions are helpful and needed</li>
                        <li>Allow your workers to receive and share information we need from other agencies, doctors, schools, etc. to access or coordinate services that you request</li>
                        <li>Try, to the best of your ability, to achieve treatment and service goals that are planned. One step at a time!</li>
                        <li>Come to counseling on time</li>
                        <li>Call if you cannot make counseling sessions</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b>NOTICE: This entire document is reprinted in the Client Handbook which every client receives.</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive	Direction  Support  Services</h3>
                </p>
                <p className='w-750'>
                    <h4> <u>Informed Consent to Treatment</u> </h4>
                </p>
                <p className='w-750'>
                    <ol>
                        <li>I will be given a clear description from my mental health provider regarding the problems, diagnosis, personal strengths/limitations and treatment interventions proposed</li>
                        <li>I will be given a dear recommendation for the types of treatment recommended, such as individual counseling/therapy,group counseling/therapy, family counseling/therapy,addictions counseling. and/or psychiatric services. Times, dates, and session length will be discussed with my mental health provider.</li>
                        <li>I voluntarily agree to undergo mental health treatment and understand that I may end treatment at any time. understand that my mental health provider may want to discuss this with me, but that I reserve the right to stop treatment. In the cases of minors, please see addendum form - 'Consent to Mental Health Treatment for MinorsN. Furthermore, I understand that my mental health provider may make diagnostic and treatment recommendations with which I do not agree (e.g. modality of treatment, duration of treatment, frequency of visits, etc.).</li>
                        <li>I understand that my mental health provider cannot guarantee results (e.g., less depressed, etc.) of mental health services. However, there will be clearly stated reasons, goals, and objectives for continuing/discontinuingmental health treatment This will be discussed with my mental health provider</li>
                        <li>I understand that there may be some risks in participating in mental health services. These may include, but are not limited to, addressing painful emotional experiences and/or feelings; being challenged or confronted on a particular issue; re-uniting with family members; etc. I am aware that I can discuss any unforeseen risks vs. benefits with my mental health provider at any time. In the case of psychiatric care, medications, side effects, and alternative treatments will be discussed</li>
                        <li>I understand that I have the right to an interpreter (sign or language) if necessary</li>
                        <li>I understand that in the case of an emergency, Positive Direction Support Services maintains a 24 hour emergency 'on call system. Emergencies are generally life-threatening in nature. I have discussed with my mental health provider how to access this service</li>
                        <li>I understand that if I have a grievance with my mental health provider, I will first attempt to communicate this directly to him/her. In the event that the grievance is not satisfactorily resolved, I understand how to complete a nReasonable Accommodations Request Form' (located in the waiting area).</li>
                        <li>I understand that this 'Informed Consent/Limits of Confidentiality Form' is not intended to be 'all inclusive' of aspects ofmy mental health treatment It is only intended to provide some useful information before deciding to engage in mental health treatment</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <h4> <u>Limits of Confidentiality</u> </h4>
                </p>
                <p className='w-750'>
                    <ol type='I'>
                        <li>The information that you share with your Mental Health Provider is considered to be confidential. In most cases, information cannot be released to another party without your written consent. However, in certain circumstances, information can be shared legally without your permission. These circumstances include:</li>
                        <ol>
                            <li>Suicide: if you are assessed to be a danger to yourself; cannot guarantee your physical safety against the intention of suicide; and/or have immediate suicidal plans, this information is not considered to be 'confidential' . Actions may be taken to ensure your safety.</li>
                            <li>Homicide: if you are assessed to be a danger to others; cannot guarantee their safety; and have immediate, specific plans to cause fatal injury/harm to another person, this information is not considered to be 'confidential'. Actions may be taken to protect the safety of others. The police may be notified of your intentions as well as the intended victim</li>
                            <li>Court order/subpoena: Your Mental Health Provider(s) can be required to relinquish a copy of your written Mental Health Record to the appropriate Courts. Mental Health Providers can also be subpoenaed to testify in court without your consent</li>
                            <p className='w-750'><h4><u>Limits of Confidentiality (con't)</u></h4></p>
                            <li>Child abuse/neglect: Louisiana Law requires your Mental Health Provider to report to the appropriate authorities (i.e. Child Protective Services) any suspicion or evidence of child abuse or neglect. This law also applies to past incidents of abuse or neglect </li>
                            <li>Laws regarding minors in mental health services: certain information may be shared with parent/legal guardians at the discretion of the mental health provider(s).</li>
                        </ol>
                        <li>Mental Health confidential information may also be used in a number of ways within Positive Direction Support Services without your written permission for coordinating services and delivering quality care. You may be informed if this is the case. These may include:</li>
                        <ol>
                            <li>Consultations and case conference with other providers at Positive Direction Support Services</li>
                            <li>In supervisory meetings with student interns at Positive Direction Support Services.</li>
                            <li>With providers in other services here at Positive Direction Support Services (your doctor, nurse, or case manager).</li>
                            <li>For anonymous research purposes at Positive Direction Support Services.</li>
                            <li>For billing purposes: a diagnosis is given to your insurer for reimbursement purposes, including Magellan of Louisiana Health Partners, Medicaid, and/or private insurance companies/HMO's.</li>
                        </ol>
                        <li>Other Notes on Your Privacy & Billing/Fee Information:</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Please indicate on the Client Demographic Form how we may contact you.</li>
                        <li>Video and audio taping: occasionally, Mental Health Providers will want to make an audio/video recording of your sessions. Your written permission in required. YOU HAVE THE RIGHT TO REFUSE THIS.</li>
                        <li>Generally, you will be contacted by phone or mail. Internet email is discouraged unless discussed with your therapist PLEASE NOTE: PRIVACY AND CONFIDENTIALITY OVER THE INTERNET CANNOT BE GUARANTEED</li>
                        <li>I have discussed my insurance coverage and fees with the Mental Health Benefits Coordinator prior to this appointment. I understand that I am responsible for any co• pays or fees not covered by third parties.</li>
                        <li>I understand that it is the policy of Positive Direction Support Services to discharge a patient after three (3) missed appointments. In the event that I do not call to cancel an appointment with 24 hours  notice this is considered to be a missed appointment It is recommended that patients do not miss appointments as these are a benefit to the patient's mental health success.</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b>I have reviewed this 'lnformed Consent to Treatment/Limits of Confidentiality' information with my mental health provider. I have been given the opportunity to ask questions about this information. A copy of this information is available upon request By signing this, I indicate my understanding of this information.</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services</h3>
                </p>
                <p className='w-750'>
                    <h3>Client Abuse and/or Neglect</h3>
                </p>
                <p className='w-750'>
                    Criminal statute L.S.A-R.S.14:403 specifies that any person in the Children's Code who is required to report abuse or neglect, including sexual abuse of a child under age18, is to report information to authorities when that person has cause to believe a child's physical or mental health or welfare is endangered. Wil1ful and knowing failure to report can result in $500.00 fine or imprisonment for six (6) months, or both.
                </p>
                <p className='w-750'>
                    La. Children's Code Art 603 defines those persons who must report child abuse as mandatory reporters, which include: any person who provides health care services, e.g., doctors, nurses, technicians; mental health or social services professionals who provide counseling services to a child or his/her family; members of the clergy; teaching or child care providers; law enforcement officers and commercial film processors.
                </p>
                <p className='w-750'>
                    Art. 603 (13) (c) provides an exception to the mandatory reporting requirement for a 'Member of the clergy.' He is not required to report a confidential communication, i.e., 'one made privately and not intended for further disclosure except to the persons present in furtherance of the communication from a person,' if the member of the clergy, in the course of the discipline or practice of that church, denomination, or organization, is authorized or accustomed to hearing confidential communications, and under the discip1ine or tenets of the church, denomination, or organization has a duty to keep such communications confidential. In that instance, the member of the clergy shall encourage that person to report the allegations to the appropriate authorities.
                </p>
                <p className='w-750'>
                    Art 610 is the reporting procedure that requires mandatory reporters to immediately report to local child protection unit of Department of Social Services in cases where the abuser is believed to be a parent, caretaker, a person who maintains an interpersonal dating or engagement relationship with the parent or caretaker, or a person living in the same residence with the parent or caretaker as spouse whether married or not. If such a person or caretaker is not believed to have any responsibility for the abuse or neglect, the report should be immediately made to the appropriate local or state Jaw enforcement agency. Dual reporting shall be permitted. The initial report may be verbal, and should contain the following information, if known:
                </p>
                <p className='w-750'>
                    <ol>
                        <ol>
                            <li>Name, address, age, sex and race of the child;</li>
                            <li>Nature, extent and cause of child's injuries or endangered condition, including any previous known or suspected abuse to the child or child's siblings;</li>
                            <li>Name and address of parent(s) or caretaker;</li>
                            <li>Names and ages of all other members of child's household;</li>
                            <li>Name and address of the reporter;</li>
                            <li>Account of how child came to reporter's attention;</li>
                            <li>Explanation of cause of child's injury or condition offered by child, the caretaker or any other person;</li>
                            <li>Any other information which the reporter believes might be important or relevant</li>
                        </ol>
                    </ol>
                </p>
                <p className='w-750'>
                    If the initial report is verbal, it shall be followed by a written report within five (5) days to the appropriate agency, i.e., local child protection unit or law enforcement agency.
                </p>
                <p className='w-750'>
                    Article 611 grants immunity from civil or criminal liability to any reporter, for the making of any report in good faith, and without knowledge of the falsity of such information, or reckless disregard for the truth of the report.
                </p>
                <p className='w-750'>
                    The Director and staff of Positive Direction will be responsible for reporting suspected abuse and/or neglect to the appropriate state agencies. PDSSS will follow all state laws in the referral of minor patients to the appropriate child protection agency. All cases will be documented in the client's chart. The telephone number for reporting suspected child abuse or neglect is:
                </p>
                <p className='w-750'>
                    <b>1-855-4LA-KIDS <br />
                        (1-855-452-5437)</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Authorization to Release or Obtain Health Information For Eligibility in Program Enrollment</h3>
                    <span className='small'>(including paper, oral and electronic information)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtRequestDate' name='txtRequestDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddress' name='txtMailingAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOBirth' name='txtDateOBirth' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Medicaid ID# or Social Security#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityStateZip' name='txtCityStateZip' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidIdOrSocialSecurity' name='txtMedicaidIdOrSocialSecurity' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I authorize:
                </p>
                <p className='w-750'>
                    <b>Name:</b>Positive Direction Support Services, LLC <br />
                    <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400 <br />
                    <b>City, State, Zip Code:</b>New Orleans, LA 70119 <br />
                    Phone#: (504) 944-0453 Office (504) 944-0095 Fax <br />
                    <b>Relationship: </b> Behavioral Health Agency
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToReleaseInformationTo' name='rbIAuthorize' className='add-only' value='ToReleaseInformationTo' /> To Release Information TO
                        </td>
                        <td className='w-100'>
                            OR
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToObtainInformationFrom' name='rbIAuthorize' className='add-only' value='ToObtainInformationFrom' /> To Obtain Information FROM
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    (Place an 'X' in the box that indicates if the information is being released OR requested.)
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Mailing Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMailingAddress_1' name='txtMailingAddress_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City, State, Zip Code: </span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityZipState' name='txtCityZipState' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Telephone#:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTelephone' name='txtTelephone' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFax' name='txtFax' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I authorize the release of the following protected health information:</span>
                    <span className='small'>(Place an x in the box (es) that apply to the information you want released or you want to obtain.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurpose_1' name='cbPurpose_1' className='add-only' value='EntireRecord' /> Entire record
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurpose_2' name='cbPurpose_2' className='add-only' value='Immunizations' /> Immunizations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurpose_3' name='cbPurpose_3' className='add-only' value='Prescriptions' /> Prescriptions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurpose_4' name='cbPurpose_4' className='add-only' value='LaboratoryReports' /> Laboratory Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurpose_5' name='cbPurpose_5' className='add-only' value='XRayReports' /> X-ray Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurpose_6' name='cbPurpose_6' className='add-only' value='MRDDReports' /> MR/DD Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurpose_7' name='cbPurpose_7' className='add-only' value='MedicalHistoryExaminationReports' /> Medical History, Examination, Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurpose_7' name='cbPurpose_7' className='add-only' value='HospitalRecordsIncludingReports' /> Hospital Records including Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurpose_8' name='cbPurpose_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following record</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_1' name='cbComplianceState_1' className='add-only' value='Alcoholism' /> Alcoholism
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_2' name='cbComplianceState_2' className='add-only' value='DrugAbuse' /> Drug Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_3' name='cbComplianceState_3' className='add-only' value='MentalHealth' /> Mental Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_4' name='cbComplianceState_4' className='add-only' value='HivAids' /> HIV (AIDS)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_5' name='cbComplianceState_5' className='add-only' value='Genetics' /> Genetics
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_6' name='cbComplianceState_6' className='add-only' value='PsychotherapyNotes' /> Psychotherapy Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceState_7' name='cbComplianceState_7' className='add-only' value='VocationalRehabilitation' /> Vocational Rehabilitation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbComplianceState_7' name='cbComplianceState_7' className='add-only' value='SexuallyTransmittedDiseases' /> Sexually Transmitted Diseases
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbComplianceState_8' name='cbComplianceState_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtComplianceStateOther' name='txtComplianceStateOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This authorization shall expire on &nbsp;<input type='text' id='txtAuthorizationShallExpire' name='txtAuthorizationShallExpire' className='add-only w-200 custom-add-only' />&nbsp;(date or event) and is needed for the period beginning &nbsp;<input type='text' id='txtPeriodBeginning' name='txtPeriodBeginning' className='add-only w-150 custom-add-only' /> &nbsp;and ending &nbsp;<input type='text' id='txtAndEnding' name='txtAndEnding' className='add-only w-150 custom-add-only' />
                </p>
                <p className='w-750'>
                    I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form
                </p>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </td>

                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Witness (ff signed with an 'X' or mark) Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Authorization to Release or Obtain Health Information For Eligibility in Program Enrollment</h3>
                    <span className='small'>(including paper, oral and electronic information)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtNameOne' name='txtNameOne' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtRequestDateOne' name='txtRequestDateOne' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddressOne' name='txtMailingAddressOne' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOBirthOne' name='One' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Medicaid ID# or Social Security#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityStateZipOne' name='txtCityStateZipOne' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidIdOrSocialSecurityOne' name='txtMedicaidIdOrSocialSecurityOne' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I authorize:
                </p>
                <p className='w-750'>
                    <b>Name:</b>Positive Direction Support Services, LLC <br />
                    <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400 <br />
                    <b>City, State, Zip Code:</b>New Orleans, LA 70119 <br />
                    Phone#: (504) 944-0453 Office (504) 944-0095 Fax <br />
                    <b>Relationship: </b> Behavioral Health Agency
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToReleaseInformationToOne' name='rbIAuthorizeOne' className='add-only' value='ToReleaseInformationTo' /> To Release Information TO
                        </td>
                        <td className='w-100'>
                            OR
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToObtainInformationFromOne' name='rbIAuthorizeOne' className='add-only' value='ToObtainInformationFrom' /> To Obtain Information FROM
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    (Place an 'X' in the box that indicates if the information is being released OR requested.)
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Mailing Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameOne_1' name='txtNameOne_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMailingAddressOne_1' name='txtMailingAddressOne_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City, State, Zip Code: </span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityZipStateOne' name='txtCityZipStateOne' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationshipOne' name='txtRelationshipOne' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Telephone#:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTelephoneOne' name='txtTelephoneOne' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFaxOne' name='txtFaxOne' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I authorize the release of the following protected health information:</span>
                    <span className='small'>(Place an x in the box (es) that apply to the information you want released or you want to obtain.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeOne_1' name='cbPurposeOne_1' className='add-only' value='EntireRecord' /> Entire record
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeOne_2' name='cbPurposeOne_2' className='add-only' value='Immunizations' /> Immunizations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeOne_3' name='cbPurposeOne_3' className='add-only' value='Prescriptions' /> Prescriptions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeOne_4' name='cbPurposeOne_4' className='add-only' value='LaboratoryReports' /> Laboratory Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeOne_5' name='cbPurposeOne_5' className='add-only' value='XRayReports' /> X-ray Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeOne_6' name='cbPurposeOne_6' className='add-only' value='MRDDReports' /> MR/DD Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurposeOne_7' name='cbPurposeOne_7' className='add-only' value='MedicalHistoryExaminationReports' /> Medical History, Examination, Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurposeOne_7' name='cbPurposeOne_7' className='add-only' value='HospitalRecordsIncludingReports' /> Hospital Records including Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurposeOne_8' name='cbPurposeOne_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtOtherOne' name='txtOtherOne' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following record</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_1' name='cbComplianceStateOne_1' className='add-only' value='Alcoholism' /> Alcoholism
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_2' name='cbComplianceStateOne_2' className='add-only' value='DrugAbuse' /> Drug Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_3' name='cbComplianceStateOne_3' className='add-only' value='MentalHealth' /> Mental Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_4' name='cbComplianceStateOne_4' className='add-only' value='HivAids' /> HIV (AIDS)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_5' name='cbComplianceStateOne_5' className='add-only' value='Genetics' /> Genetics
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_6' name='cbComplianceStateOne_6' className='add-only' value='PsychotherapyNotes' /> Psychotherapy Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateOne_7' name='cbComplianceStateOne_7' className='add-only' value='VocationalRehabilitation' /> Vocational Rehabilitation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbComplianceStateOne_7' name='cbComplianceStateOne_7' className='add-only' value='SexuallyTransmittedDiseases' /> Sexually Transmitted Diseases
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbComplianceStateOne_8' name='cbComplianceStateOne_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtComplianceStateOneOther' name='txtComplianceStateOneOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This authorization shall expire on &nbsp;<input type='text' id='txtAuthorizationShallExpireOne' name='txtAuthorizationShallExpireOne' className='add-only w-200 custom-add-only' />&nbsp;(date or event) and is needed for the period beginning &nbsp;<input type='text' id='txtPeriodBeginningOne' name='txtPeriodBeginningOne' className='add-only w-150 custom-add-only' /> &nbsp;and ending &nbsp;<input type='text' id='txtAndEndingOne' name='txtAndEndingOne' className='add-only w-150 custom-add-only' />
                </p>
                <p className='w-750'>
                    I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form
                </p>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </td>

                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Witness (ff signed with an 'X' or mark) Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Authorization to Release or Obtain Health Information For Eligibility in Program Enrollment</h3>
                    <span className='small'>(including paper, oral and electronic information)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtNameTwo' name='txtNameTwo' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtRequestDateTwo' name='txtRequestDateTwo' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddressTwo' name='txtMailingAddressTwo' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOBirthTwo' name='Two' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Medicaid ID# or Social Security#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityStateZipTwo' name='txtCityStateZipTwo' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidIdOrSocialSecurityTwo' name='txtMedicaidIdOrSocialSecurityTwo' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I authorize:
                </p>
                <p className='w-750'>
                    <b>Name:</b>Positive Direction Support Services, LLC <br />
                    <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400 <br />
                    <b>City, State, Zip Code:</b>New Orleans, LA 70119 <br />
                    Phone#: (504) 944-0453 Office (504) 944-0095 Fax <br />
                    <b>Relationship: </b> Behavioral Health Agency
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToReleaseInformationToTwo' name='rbIAuthorizeTwo' className='add-only' value='ToReleaseInformationTo' /> To Release Information TO
                        </td>
                        <td className='w-100'>
                            OR
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToObtainInformationFromTwo' name='rbIAuthorizeTwo' className='add-only' value='ToObtainInformationFrom' /> To Obtain Information FROM
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    (Place an 'X' in the box that indicates if the information is being released OR requested.)
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Mailing Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameTwo_1' name='txtNameTwo_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMailingAddressTwo_1' name='txtMailingAddressTwo_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City, State, Zip Code: </span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityZipStateTwo' name='txtCityZipStateTwo' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationshipTwo' name='txtRelationshipTwo' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Telephone#:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTelephoneTwo' name='txtTelephoneTwo' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFaxTwo' name='txtFaxTwo' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I authorize the release of the following protected health information:</span>
                    <span className='small'>(Place an x in the box (es) that apply to the information you want released or you want to obtain.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeTwo_1' name='cbPurposeTwo_1' className='add-only' value='EntireRecord' /> Entire record
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeTwo_2' name='cbPurposeTwo_2' className='add-only' value='Immunizations' /> Immunizations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeTwo_3' name='cbPurposeTwo_3' className='add-only' value='Prescriptions' /> Prescriptions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeTwo_4' name='cbPurposeTwo_4' className='add-only' value='LaboratoryReports' /> Laboratory Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeTwo_5' name='cbPurposeTwo_5' className='add-only' value='XRayReports' /> X-ray Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeTwo_6' name='cbPurposeTwo_6' className='add-only' value='MRDDReports' /> MR/DD Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurposeTwo_7' name='cbPurposeTwo_7' className='add-only' value='MedicalHistoryExaminationReports' /> Medical History, Examination, Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurposeTwo_7' name='cbPurposeTwo_7' className='add-only' value='HospitalRecordsIncludingReports' /> Hospital Records including Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurposeTwo_8' name='cbPurposeTwo_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtOtherTwo' name='txtOtherTwo' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following record</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_1' name='cbComplianceStateTwo_1' className='add-only' value='Alcoholism' /> Alcoholism
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_2' name='cbComplianceStateTwo_2' className='add-only' value='DrugAbuse' /> Drug Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_3' name='cbComplianceStateTwo_3' className='add-only' value='MentalHealth' /> Mental Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_4' name='cbComplianceStateTwo_4' className='add-only' value='HivAids' /> HIV (AIDS)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_5' name='cbComplianceStateTwo_5' className='add-only' value='Genetics' /> Genetics
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_6' name='cbComplianceStateTwo_6' className='add-only' value='PsychotherapyNotes' /> Psychotherapy Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateTwo_7' name='cbComplianceStateTwo_7' className='add-only' value='VocationalRehabilitation' /> Vocational Rehabilitation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbComplianceStateTwo_7' name='cbComplianceStateTwo_7' className='add-only' value='SexuallyTransmittedDiseases' /> Sexually Transmitted Diseases
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbComplianceStateTwo_8' name='cbComplianceStateTwo_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtComplianceStateTwoOther' name='txtComplianceStateTwoOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This authorization shall expire on &nbsp;<input type='text' id='txtAuthorizationShallExpireTwo' name='txtAuthorizationShallExpireTwo' className='add-only w-200 custom-add-only' />&nbsp;(date or event) and is needed for the period beginning &nbsp;<input type='text' id='txtPeriodBeginningTwo' name='txtPeriodBeginningTwo' className='add-only w-150 custom-add-only' /> &nbsp;and ending &nbsp;<input type='text' id='txtAndEndingTwo' name='txtAndEndingTwo' className='add-only w-150 custom-add-only' />
                </p>
                <p className='w-750'>
                    I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form
                </p>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </td>

                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Witness (ff signed with an 'X' or mark) Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Authorization to Release or Obtain Health Information For Eligibility in Program Enrollment</h3>
                    <span className='small'>(including paper, oral and electronic information)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Request Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtNameThree' name='txtNameThree' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtRequestDateThree' name='txtRequestDateThree' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Mailing Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtMailingAddressThree' name='txtMailingAddressThree' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOBirthThree' name='Three' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Medicaid ID# or Social Security#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityStateZipThree' name='txtCityStateZipThree' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidIdOrSocialSecurityThree' name='txtMedicaidIdOrSocialSecurityThree' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I authorize:
                </p>
                <p className='w-750'>
                    <b>Name:</b>Positive Direction Support Services, LLC <br />
                    <b>Mailing Address:</b> 1995 Gentilly Blvd. Suite C-400 <br />
                    <b>City, State, Zip Code:</b>New Orleans, LA 70119 <br />
                    Phone#: (504) 944-0453 Office (504) 944-0095 Fax <br />
                    <b>Relationship: </b> Behavioral Health Agency
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToReleaseInformationToThree' name='rbIAuthorizeThree' className='add-only' value='ToReleaseInformationTo' /> To Release Information TO
                        </td>
                        <td className='w-100'>
                            OR
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAuthorize_ToObtainInformationFromThree' name='rbIAuthorizeThree' className='add-only' value='ToObtainInformationFrom' /> To Obtain Information FROM
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    (Place an 'X' in the box that indicates if the information is being released OR requested.)
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Mailing Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameThree_1' name='txtNameThree_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMailingAddressThree_1' name='txtMailingAddressThree_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>City, State, Zip Code: </span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCityZipStateThree' name='txtCityZipStateThree' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationshipThree' name='txtRelationshipThree' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Telephone#:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax#:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTelephoneThree' name='txtTelephoneThree' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFaxThree' name='txtFaxThree' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I authorize the release of the following protected health information:</span>
                    <span className='small'>(Place an x in the box (es) that apply to the information you want released or you want to obtain.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeThree_1' name='cbPurposeThree_1' className='add-only' value='EntireRecord' /> Entire record
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeThree_2' name='cbPurposeThree_2' className='add-only' value='Immunizations' /> Immunizations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeThree_3' name='cbPurposeThree_3' className='add-only' value='Prescriptions' /> Prescriptions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeThree_4' name='cbPurposeThree_4' className='add-only' value='LaboratoryReports' /> Laboratory Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeThree_5' name='cbPurposeThree_5' className='add-only' value='XRayReports' /> X-ray Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPurposeThree_6' name='cbPurposeThree_6' className='add-only' value='MRDDReports' /> MR/DD Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurposeThree_7' name='cbPurposeThree_7' className='add-only' value='MedicalHistoryExaminationReports' /> Medical History, Examination, Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPurposeThree_7' name='cbPurposeThree_7' className='add-only' value='HospitalRecordsIncludingReports' /> Hospital Records including Reports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurposeThree_8' name='cbPurposeThree_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtOtherThree' name='txtOtherThree' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>In compliance with state and/or federal laws which require special permission to release otherwise privileged information, please release the following record</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_1' name='cbComplianceStateThree_1' className='add-only' value='Alcoholism' /> Alcoholism
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_2' name='cbComplianceStateThree_2' className='add-only' value='DrugAbuse' /> Drug Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_3' name='cbComplianceStateThree_3' className='add-only' value='MentalHealth' /> Mental Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_4' name='cbComplianceStateThree_4' className='add-only' value='HivAids' /> HIV (AIDS)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_5' name='cbComplianceStateThree_5' className='add-only' value='Genetics' /> Genetics
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_6' name='cbComplianceStateThree_6' className='add-only' value='PsychotherapyNotes' /> Psychotherapy Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbComplianceStateThree_7' name='cbComplianceStateThree_7' className='add-only' value='VocationalRehabilitation' /> Vocational Rehabilitation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbComplianceStateThree_7' name='cbComplianceStateThree_7' className='add-only' value='SexuallyTransmittedDiseases' /> Sexually Transmitted Diseases
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbComplianceStateThree_8' name='cbComplianceStateThree_8' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtComplianceStateThreeOther' name='txtComplianceStateThreeOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This authorization shall expire on &nbsp;<input type='text' id='txtAuthorizationShallExpireThree' name='txtAuthorizationShallExpireThree' className='add-only w-200 custom-add-only' />&nbsp;(date or event) and is needed for the period beginning &nbsp;<input type='text' id='txtPeriodBeginningThree' name='txtPeriodBeginningThree' className='add-only w-150 custom-add-only' /> &nbsp;and ending &nbsp;<input type='text' id='txtAndEndingThree' name='txtAndEndingThree' className='add-only w-150 custom-add-only' />
                </p>
                <p className='w-750'>
                    I understand that if I do not specify an expiration date, this authorization will expire one (1) year from the date on which it was signed. I acknowledge that I have read this form
                </p>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Individual or Personal Representative Authorized by Law Date </td>

                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Witness (ff signed with an 'X' or mark) Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Parental Consent Form for School Visit</h3>
                </p>
                <p className='w-750'>
                    I,<input type='text' id='txtParentGuardianConsentDecline' name='txtParentGuardianConsentDecline' className='add-only w-350 custom-add-only' /> (parent/guardian) consent/ decline for my child <input type='text' id='txtConsentDecline' name='txtConsentDecline' className='add-only w-200 custom-add-only' />
                    to be seen at his/her school <input type='text' id='txtToBeSeenAtHisHerSchool' name='txtToBeSeenAtHisHerSchool' className='add-only w-250 custom-add-only' />
                </p>
                <p className='w-750'>
                    (name of school) by the staff of Positive Direction Support Services during the academic school
                </p>
                <p className='w-750'>
                    year<input type='text' id='txtYearTheSchool' name='txtYearTheSchool' className='add-only w-100 custom-add-only' />The school's telephone number is'<input type='text' id='txtChildTelephoneSchool' name='txtChildTelephoneSchool' className='add-only w-200 custom-add-only' />My child's
                </p>
                <p className='w-750'>
                    teacher is <input type='text' id='txtTeacherIs' name='txtTeacherIs' className='add-only w-300 custom-add-only' />
                </p>
                <p className='w-750'>
                    By granting consent, I am allowing the staff from Positive Direction Services to share information, including Psychiatric diagnosis, medications and the treatment plan with the appropriate school personnel (e.g., Principal, Social Worker, School Counselor, or Sp. Education Teacher) consistent with HIPAA requirements.
                </p>
                <p className='w-750'>
                    l am also giving permission for the above named school to share information with Positive Direction Support Services, including the child's progress both academically and behaviorally, along with any IEP, lAP or other pertinent information where applicable.
                </p>
                <p className='w-750'>
                    You may contact Positive Direction Support Services at 504-944-0453 with any questions.
                </p>
                <p className='w-750'>
                    Sincerely,
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Guardian Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        NICHQ Vanderbilt Assessment Scales-TEACHER Informant
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Teacher's Name:</span>
                            <input type='text' id='txtTeacherName' name='txtTeacherName' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Class Time</span>
                            <input type='time' id='txtClassTime' name='txtClassTime' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Class Name/Period:</span>
                            <input type='text' id='txtClassNAmePeriod' name='txtClassNAmePeriod' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Today's Date: </span>
                            <input type='date' id='txtTodayDate' name='txtTodayDate' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Child's Name:</span>
                            <input type='text' id='txtChildsName' name='txtChildsName' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Grade Level:</span>
                            <input type='text' id='txtGradeLevel' name='txtGradeLevel' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Directions: </b>Each rating should be considered in the context of what is appropriate for the age of the child you are rating and should reflect that child's behavior since the beginning of the school year.Please indicate the number of weeks or months you have been able to evaluate the behaviors: <input type='text' id='txtBehavioursEvaaluate' name='txtBehavioursEvaaluate' className='add-only w-150 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is this evaluation based on a time when the child</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbWasOnMedication' name='cbWasOnMedication' className='add-only' value='WasOnMedication' /> was on medication</td>
                        <td className='w-250'><input type='checkbox' id='cbWasNotOnMedication' name='cbWasNotOnMedication' className='add-only' value='WasNotOnMedication' /> was not on medication</td>
                        <td className='w-250'><input type='checkbox' id='cbNotSure' name='cbNotSure' className='add-only' value='NotSure' /> notsure?</td>
                    </tr>
                </table>
                <table className='altRows'>
                    <tr>
                        <td className='w-400'><span className='eleHeader'>Symptoms</span></td>
                        <td className='w-75'><span className='eleHeader'>Never = 0</span></td>
                        <td className=' w-100'><span className='eleHeader'>Occasionally = 1</span></td>
                        <td className='w-75'><span className='eleHeader'>Often = 2</span></td>
                        <td className=' w-100'><span className='eleHeader'>Very Often = 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>1. Fails to give attention to details or makes careless mistakes in schoolwork</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsNever' name='rbSymptomsFails' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsOccasionally' name='rbSymptomsFails' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsOften' name='rbSymptomsFails' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsVeryOften' name='rbSymptomsFails' className='add-only' value='4' /> 3</center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>2. Has difficuJty sustaining attention to tasks or activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyOne' name='rbSymptomsHasDifficulty' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficulty_2' name='rbSymptomsHasDifficulty' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficulty_3' name='rbSymptomsHasDifficulty' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficulty_4' name='rbSymptomsHasDifficulty' className='add-only' value='4' />  3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>3. Does not seem to listen when spoken to directly </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDoesNotListen_1' name='rbSymptomsDoesNotListen' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDoesNotListen_2' name='rbSymptomsDoesNotListen' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDoesNotListen_3' name='rbSymptomsDoesNotListen' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDoesNotListen_4' name='rbSymptomsDoesNotListen' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>4. Does not follow through on instructions and fails to finish schoolwork  (not due to oppositional behavior or failure to understand)</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDoesNotFollow_1' name='rbSymptomsDoesNotFollow' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDoesNotFollow_2' name='rbSymptomsDoesNotFollow' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDoesNotFollow_3' name='rbSymptomsDoesNotFollow' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDoesNotFollow_4' name='rbSymptomsDoesNotFollow' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>5. Has difficulty organizing tasks and activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyOrganizing_1' name='rbSymptomsHasDifficultyOrganizing' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficultyOrganizing_2' name='rbSymptomsHasDifficultyOrganizing' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyOrganizing_3' name='rbSymptomsHasDifficultyOrganizing' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficultyOrganizing_4' name='rbSymptomsHasDifficultyOrganizing' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>6. Avoids, dislikes, or is reluctant to engage in tasks that require sustained mental effort</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsAvoidDislike_1' name='rbSymptomsAvoidDislike' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsAvoidDislike_2' name='rbSymptomsAvoidDislike' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsAvoidDislike_3' name='rbSymptomsAvoidDislike' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsAvoidDislike_4' name='rbSymptomsAvoidDislike' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> 7.	Loses things necessary for tasks or activities (school assignments, pencils, or books)</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLosesThingsNecessary_1' name='rbSymptomsLosesThingsNecessary' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLosesThingsNecessary_2' name='rbSymptomsLosesThingsNecessary' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLosesThingsNecessary_3' name='rbSymptomsLosesThingsNecessary' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLosesThingsNecessary_4' name='rbSymptomsLosesThingsNecessary' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>8. Is easily distracted by extraneous stimuli</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsExtraneousStimuli_1' name='rbSymptomsExtraneousStimuli' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsExtraneousStimuli_2' name='rbSymptomsExtraneousStimuli' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsExtraneousStimuli_3' name='rbSymptomsExtraneousStimuli' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsExtraneousStimuli_4' name='rbSymptomsExtraneousStimuli' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>9. Is forgetful in daily activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsForgiveDaily_1' name='rbSymptomsIsForgiveDaily' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsForgiveDaily_2' name='rbSymptomsIsForgiveDaily' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsForgiveDaily_3' name='rbSymptomsIsForgiveDaily' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsForgiveDaily_4' name='rbSymptomsIsForgiveDaily' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>10. Fidgets with hands or feet or squirms in seat</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFigetHands_1' name='rbSymptomsFigetHands' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFigetHands_2' name='rbSymptomsFigetHands' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFigetHands_3' name='rbSymptomsFigetHands' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFigetHands_4' name='rbSymptomsFigetHands' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>11. Leaves seat in classroom or in other situations in which remaining seated is expected</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLeavesSeatClassroom_1' name='rbSymptomsLeavesSeatClassroom' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLeavesSeatClassroom_2' name='rbSymptomsLeavesSeatClassroom' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLeavesSeatClassroom_3' name='rbSymptomsLeavesSeatClassroom' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLeavesSeatClassroom_4' name='rbSymptomsLeavesSeatClassroom' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>12. Runs about or climbs excessively in situations in which remaining seated is expected</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsRunsAboutClimbs_1' name='rbSymptomsRunsAboutClimbs' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsRunsAboutClimbs_2' name='rbSymptomsRunsAboutClimbs' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsRunsAboutClimbs_3' name='rbSymptomsRunsAboutClimbs' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsRunsAboutClimbs_4' name='rbSymptomsRunsAboutClimbs' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>13. Has difficulty playing or engaging in leisure activities quietly</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyPlayingEngaging_1' name='rbSymptomsHasDifficultyPlayingEngaging' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficultyPlayingEngaging_2' name='rbSymptomsHasDifficultyPlayingEngaging' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyPlayingEngaging_3' name='rbSymptomsHasDifficultyPlayingEngaging' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficultyPlayingEngaging_4' name='rbSymptomsHasDifficultyPlayingEngaging' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>14. Is 'on the go' or often acts as if 'driven by a motor'</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsOnisTheGo_1' name='rbSymptomsOnisTheGo' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsOnisTheGo_2' name='rbSymptomsOnisTheGo' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsOnisTheGo_3' name='rbSymptomsOnisTheGo' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsOnisTheGo_4' name='rbSymptomsOnisTheGo' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>15. Talks too excessively</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsExcessivelyTalks_1' name='rbSymptomsExcessivelyTalks' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsExcessivelyTalks_2' name='rbSymptomsExcessivelyTalks' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsExcessivelyTalks_3' name='rbSymptomsExcessivelyTalks' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsExcessivelyTalks_4' name='rbSymptomsExcessivelyTalks' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>16. Blurts out answers before questions have been completed</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsBlurtAnswer_1' name='rbSymptomsBlurtAnswer' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsBlurtAnswer_2' name='rbSymptomsBlurtAnswer' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsBlurtAnswer_3' name='rbSymptomsBlurtAnswer' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsBlurtAnswer_4' name='rbSymptomsBlurtAnswer' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>17. Has difficulty waiting in line</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyWaiting_1' name='rbSymptomsHasDifficultyWaiting' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficultyWaiting_2' name='rbSymptomsHasDifficultyWaiting' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasDifficultyWaiting_3' name='rbSymptomsHasDifficultyWaiting' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasDifficultyWaiting_4' name='rbSymptomsHasDifficultyWaiting' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>18. Interrupts or intrudes on others (eg,_butts into conversations/games)</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsInterruptsIntrudes_1' name='rbSymptomsInterruptsIntrudes' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsInterruptsIntrudes_2' name='rbSymptomsInterruptsIntrudes' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsInterruptsIntrudes_3' name='rbSymptomsInterruptsIntrudes' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsInterruptsIntrudes_4' name='rbSymptomsInterruptsIntrudes' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>19. Loses temper</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLosTemper_1' name='rbSymptomsLosTemper' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLosTemper_2' name='rbSymptomsLosTemper' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLosTemper_3' name='rbSymptomsLosTemper' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLosTemper_4' name='rbSymptomsLosTemper' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>20. Actively defies or refuses to comply with adults' requests or rules</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsActivelyDefiesRefuses_1' name='rbSymptomsActivelyDefiesRefuses' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsActivelyDefiesRefuses_2' name='rbSymptomsActivelyDefiesRefuses' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsActivelyDefiesRefuses_3' name='rbSymptomsActivelyDefiesRefuses' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsActivelyDefiesRefuses_4' name='rbSymptomsActivelyDefiesRefuses' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>21. Is angry or resentful</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsAngryResentful_1' name='rbSymptomsIsAngryResentful' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsAngryResentful_2' name='rbSymptomsIsAngryResentful' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsAngryResentful_3' name='rbSymptomsIsAngryResentful' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsAngryResentful_4' name='rbSymptomsIsAngryResentful' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>22. Deliberately annoys people</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDeliberatelyAnnoys_1' name='rbSymptomsDeliberatelyAnnoys' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDeliberatelyAnnoys_2' name='rbSymptomsDeliberatelyAnnoys' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDeliberatelyAnnoys_3' name='rbSymptomsDeliberatelyAnnoys' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDeliberatelyAnnoys_4' name='rbSymptomsDeliberatelyAnnoys' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>23. Is spiteful and vindictive </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsSpitefulVindictive_1' name='rbSymptomsIsSpitefulVindictive' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsSpitefulVindictive_2' name='rbSymptomsIsSpitefulVindictive' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsSpitefulVindictive_3' name='rbSymptomsIsSpitefulVindictive' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsSpitefulVindictive_4' name='rbSymptomsIsSpitefulVindictive' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>24. Initiates physical fights</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsInitiatesPhysicalFights_1' name='rbSymptomsInitiatesPhysicalFights' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsInitiatesPhysicalFights_2' name='rbSymptomsInitiatesPhysicalFights' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsInitiatesPhysicalFights_3' name='rbSymptomsInitiatesPhysicalFights' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsInitiatesPhysicalFights_4' name='rbSymptomsInitiatesPhysicalFights' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>25. Lies to obtain goods for favours or to avoid obligations (i.e., 'cons' others)</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLiesObtainGoodsFAvoursro_1' name='rbSymptomsLiesObtainGoodsFAvoursro' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLiesObtainGoodsFAvoursro_2' name='rbSymptomsLiesObtainGoodsFAvoursro' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsLiesObtainGoodsFAvoursro_3' name='rbSymptomsLiesObtainGoodsFAvoursro' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsLiesObtainGoodsFAvoursro_4' name='rbSymptomsLiesObtainGoodsFAvoursro' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>26. Is physically cruel to people</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsPhysicallySiCruel_1' name='rbSymptomsPhysicallySiCruel' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsPhysicallySiCruel_2' name='rbSymptomsPhysicallySiCruel' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsPhysicallySiCruel_3' name='rbSymptomsPhysicallySiCruel' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsPhysicallySiCruel_4' name='rbSymptomsPhysicallySiCruel' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>27. Has stolen items of nontrivial value</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasStolenItemsNontrivial_1' name='rbSymptomsHasStolenItemsNontrivial' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasStolenItemsNontrivial_2' name='rbSymptomsHasStolenItemsNontrivial' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsHasStolenItemsNontrivial_3' name='rbSymptomsHasStolenItemsNontrivial' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsHasStolenItemsNontrivial_4' name='rbSymptomsHasStolenItemsNontrivial' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>28. Deliberately destroys others' property</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDeliberatelyDestroyRopety_1' name='rbSymptomsDeliberatelyDestroyRopety' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDeliberatelyDestroyRopety_2' name='rbSymptomsDeliberatelyDestroyRopety' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsDeliberatelyDestroyRopety_3' name='rbSymptomsDeliberatelyDestroyRopety' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsDeliberatelyDestroyRopety_4' name='rbSymptomsDeliberatelyDestroyRopety' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>29. Is fearful, anxious, or worried</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFearfulAnxiosu_1' name='rbSymptomsFearfulAnxiosu' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFearfulAnxiosu_2' name='rbSymptomsFearfulAnxiosu' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFearfulAnxiosu_3' name='rbSymptomsFearfulAnxiosu' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFearfulAnxiosu_4' name='rbSymptomsFearfulAnxiosu' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>30. Is afraid to try new things for fear of making mistakes</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsAfraidTryWenThings_1' name='rbSymptomsAfraidTryWenThings' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsAfraidTryWenThings_2' name='rbSymptomsAfraidTryWenThings' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsAfraidTryWenThings_3' name='rbSymptomsAfraidTryWenThings' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsAfraidTryWenThings_4' name='rbSymptomsAfraidTryWenThings' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>31. Is self-conscious or easily embarrassed</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsSelfConsiousEasily_1' name='rbSymptomsSelfConsiousEasily' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsSelfConsiousEasily_2' name='rbSymptomsSelfConsiousEasily' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsSelfConsiousEasily_3' name='rbSymptomsSelfConsiousEasily' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsSelfConsiousEasily_4' name='rbSymptomsSelfConsiousEasily' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>32. Feels worthless or inferior</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFeelsWarthelssInferior_1' name='rbSymptomsFeelsWarthelssInferior' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFeelsWarthelssInferior_2' name='rbSymptomsFeelsWarthelssInferior' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFeelsWarthelssInferior_3' name='rbSymptomsFeelsWarthelssInferior' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFeelsWarthelssInferior_4' name='rbSymptomsFeelsWarthelssInferior' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>33. Blames self for problems, feels guilty</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsBlamesSelf_1' name='rbSymptomsBlamesSelf' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsBlamesSelf_2' name='rbSymptomsBlamesSelf' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsBlamesSelf_3' name='rbSymptomsBlamesSelf' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsBlamesSelf_4' name='rbSymptomsBlamesSelf' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>34. Feels lonely, unwanted, or unloved; complains that 'no one loves him or her'</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFeelsLonelyUnwamtes_1' name='rbSymptomsFeelsLonelyUnwamtes' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFeelsLonelyUnwamtes_2' name='rbSymptomsFeelsLonelyUnwamtes' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsFeelsLonelyUnwamtes_3' name='rbSymptomsFeelsLonelyUnwamtes' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsFeelsLonelyUnwamtes_4' name='rbSymptomsFeelsLonelyUnwamtes' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>35. Is sad, unhappy, or depressed</td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsSadDepressed_1' name='rbSymptomsIsSadDepressed' className='add-only' value='1' /> 0 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsSadDepressed_2' name='rbSymptomsIsSadDepressed' className='add-only' value='2' /> 1 </center> </td>
                        <td className=' w-75'><center><input type='radio' id='rbSymptomsIsSadDepressed_3' name='rbSymptomsIsSadDepressed' className='add-only' value='3' /> 2 </center> </td>
                        <td className=' w-100'><center><input type='radio' id='rbSymptomsIsSadDepressed_4' name='rbSymptomsIsSadDepressed' className='add-only' value='4' /> 3</center> </td>
                    </tr>
                </table>
                <table className='altRows'>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Performance</span></td>
                        <td className='w-75'><span className='eleHeader'>Excellent = 1</span></td>
                        <td className='w-100'><span className='eleHeader'>Above Average = 2</span></td>
                        <td className='w-75'><span className='eleHeader'>Average = 3</span></td>
                        <td className='w-150'><span className='eleHeader'>Somewhat of a Problem = 4</span></td>
                        <td className='w-100'><span className='eleHeader'>Problematic = 5</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>36. Reading</td>
                        <td className='w-75'><center><input type='radio' id='rbPerFormanceReading_1' name='rbPerformance' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbPerFormanceReading_2' name='rbPerformance' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbPerFormanceReading_3' name='rbPerformance' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbPerFormanceReading_4' name='rbPerformance' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbPerFormanceReading_5' name='rbPerformance' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>37. Writing</td>
                        <td className='w-75'><center><input type='radio' id='rbPerformanceWriting_1' name='rbPerformanceWriting' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbPerformanceWriting_2' name='rbPerformanceWriting' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbPerformanceWriting_3' name='rbPerformanceWriting' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbPerformanceWriting_4' name='rbPerformanceWriting' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbPerformanceWriting_5' name='rbPerformanceWriting' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>38. Mathematics</td>
                        <td className='w-75'><center><input type='radio' id='rbPerformanceMathematics_1' name='rbPerformanceMathematics' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbPerformanceMathematics_2' name='rbPerformanceMathematics' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbPerformanceMathematics_3' name='rbPerformanceMathematics' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbPerformanceMathematics_4' name='rbPerformanceMathematics' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbPerformanceMathematics_5' name='rbPerformanceMathematics' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                </table>
                <table className='altRows'>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Classroom Behavioral Performance</span></td>
                        <td className='w-75'><span className='eleHeader'>Excellent = 1</span></td>
                        <td className='w-100'><span className='eleHeader'>Above Average = 2</span></td>
                        <td className='w-75'><span className='eleHeader'>Average = 3</span></td>
                        <td className='w-150'><span className='eleHeader'>Somewhat of a Problem = 4</span></td>
                        <td className='w-100'><span className='eleHeader'>Problematic = 5</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>39. Relationship with peers</td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomRelationShip_1' name='rbClassRoomRelationShip' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomRelationShip_2' name='rbClassRoomRelationShip' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomRelationShip_3' name='rbClassRoomRelationShip' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbClassRoomRelationShip_4' name='rbClassRoomRelationShip' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomRelationShip_5' name='rbClassRoomRelationShip' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>40. Following Directions</td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomFollowing_1' name='rbClassRoomFollowing' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomFollowing_2' name='rbClassRoomFollowing' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomFollowing_3' name='rbClassRoomFollowing' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbClassRoomFollowing_4' name='rbClassRoomFollowing' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomFollowing_5' name='rbClassRoomFollowing' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>41. Disrupting class </td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomDisrupting_1' name='rbClassRoomDisrupting' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomDisrupting_2' name='rbClassRoomDisrupting' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomDisrupting_3' name='rbClassRoomDisrupting' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbClassRoomDisrupting_4' name='rbClassRoomDisrupting' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomDisrupting_5' name='rbClassRoomDisrupting' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>42. Organizational skills</td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomOrganizational_1' name='rbClassRoomOrganizational' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomOrganizational_2' name='rbClassRoomOrganizational' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomOrganizational_3' name='rbClassRoomOrganizational' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbClassRoomOrganizational_4' name='rbClassRoomOrganizational' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomOrganizational_5' name='rbClassRoomOrganizational' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>43. Assignment Completion</td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomAssignment_1' name='rbClassRoomAssignment' className='add-only' value='1' /> 1 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomAssignment_2' name='rbClassRoomAssignment' className='add-only' value='2' /> 2 </center></td>
                        <td className='w-75'><center><input type='radio' id='rbClassRoomAssignment_3' name='rbClassRoomAssignment' className='add-only' value='3' /> 3 </center></td>
                        <td className='w-150'><center><input type='radio' id='rbClassRoomAssignment_4' name='rbClassRoomAssignment' className='add-only' value='4' /> 4 </center></td>
                        <td className='w-100'><center><input type='radio' id='rbClassRoomAssignment_5' name='rbClassRoomAssignment' className='add-only' value='5' /> 5 </center></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Please return this form to:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPleaseReturnThisForm' name='txtPleaseReturnThisForm' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFaxNumber' name='txtFaxNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Mailing Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtMailingAddressFour' name='txtMailingAddressFour' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>For Office Use Only</span>
                </p>
                <table>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 1-9:</td>
                        <td className='w-150'><input type='text' id='txtTotal_1' name='txtTotal_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 10-18:</td>
                        <td className='w-150'><input type='text' id='txtTotal_2' name='txtTotal_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total Symptom Score for questions 1-18:</td>
                        <td className='w-150'><input type='text' id='txtTotal_3' name='txtTotal_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 19-26:</td>
                        <td className='w-150'><input type='text' id='txtTotal_4' name='txtTotal_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 27-40:</td>
                        <td className='w-150'><input type='text' id='txtTotal_5' name='txtTotal_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 41-47:</td>
                        <td className='w-150'><input type='text' id='txtTotal_6' name='txtTotal_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 4 or 5 in questions 48-55:</td>
                        <td className='w-150'><input type='text' id='txtTotal_7' name='txtTotal_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Average Performance Score:</td>
                        <td className='w-150'><input type='text' id='txtTotal_8' name='txtTotal_8' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services, LLC </h3>
                </p>
                <p className='w-750'>
                    <h3>Emergency	Contact Information </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Client's Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Client's DOB:</span> </td>
                        <td className='w-300'> <span className='eleHeader'> Client's SSN:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtClientNameOne' name='txtClientNameOne' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDOBDateOfBirthOne' name='txtDOBDateOfBirthOne' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtClientSsnOne' name='txtClientSsnOne' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Parent/Guardian's Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtParentGuardianName' name='txtParentGuardianName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Contact Numbers:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Home:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Work:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtContactHome' name='txtContactHome' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtContactWork' name='txtContactWork' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Cell:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Other:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtContactCell' name='txtContactCell' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtContactOther' name='txtContactOther' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Additional Emergency Contact Numbers:</b> {`(Please include ALL supports POSS can contact in regards to medication management and follow up with treatment in case of a hurricane and/or natural disaster.)`}
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameEmergency_1' name='txtNameEmergency_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationship_1' name='txtRelationship_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Phone Numbers:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameEmergency_2' name='txtNameEmergency_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationship_2' name='txtRelationship_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Phone Numbers:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameEmergency_3' name='txtNameEmergency_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationship_3' name='txtRelationship_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Phone Numbers:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPhoneNumber_3' name='txtPhoneNumber_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`IF AN EVACUATION IS NECESSARY, PLEASE MAKE EVERY EFFORT TO PIAN AHEAD WITH YOUR CH1U>ANDTAK£ALONG HIS/HER MEDICATION AND TREATMENT PLANS (1.E, BEHAVIOR, SAFETY, MONITORING, ETC.). IF THE OFFICE IS Cl.OSED  FOR A PERIOD OFTIME ANO POSS IS UNABLE TO CONTAOY0U, PLEASE CONTACT OUR EXECUTIVE DIRECTOR, D0NNYETTE Love AT(504) 421 2107 FOR OFFICE INFORMATION, PLEASE CALL THE OFFICE OF MENTAL HEALTH FOR ACCESS TO MENTAL HEALTH SERVICES AT 1{800) 558-4617,`}
                </p>
                <p className='w-750'>
                    {`The following signature acknowledges that you give POSS permission to contact the above person(s) and number(s) in the event of a hurricane/natural disaster`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Guardian </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services</h3>
                </p>
                <p className='w-750'>
                    <h3>Client Contract</h3>
                </p>
                <p className='w-750'>
                    I <input type='text' id='txtPositiveDirectionSupport' name='txtPositiveDirectionSupport' className='add-only w-200 custom-add-only' /> understand and agree to comply with the following terms of this contract:
                </p>
                <p className='w-750'>
                    <ol type='A'>
                        <li>I agree to make every effort not to harm self or others.</li>
                        <li>I will try to encourage myself from even considering harming self or others.</li>
                        <li>In the event of an emergency/crisis, I agree to contact Positive Direction as soon as possible:</li>
                    </ol>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>&nbsp;</td>
                        <td className='w-300'>
                            <b>{`(504) 944-0453 or (504) 944-0417`}</b>
                        </td>
                        <td className='w-300'>
                            <b>{`8:30 AM - 5:00 PM, Mon - Fri`}</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>&nbsp;</td>
                        <td className='w-300'>
                            <b>{`(504) 421-2107`}</b>
                        </td>
                        <td className='w-300'>
                            <b>{`After Hours/Crisis Number`}</b>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Example of where emergency/ crisis contact is needed:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>I am thinking about hurting myself or others.</li>
                        <li>I am unmanageable and not cooperating with taking medication.</li>
                        <li>I am at risk due to refusing prescribed' treatment of a coexisting medical condition.</li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/LEGAL GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services </h3>
                </p>
                <p className='w-750'>
                    <h3>Discharge Policy</h3>
                </p>
                <p className='w-750'>
                    A child may be released from the services offered by Positive Direction Support Services Behavioral Health Agency for the following reasons:
                </p>
                <p className='w-750'>
                    <ol type='a'>
                        <li>Symptoms Resolved;</li>
                        <li>Treatment goals are met;</li>
                        <li>Non-compliance with program requirements or</li>
                        <li>Three (3) missed scheduled appointments</li>
                    </ol>
                </p>
                <p className='w-750'>
                    Program expectations are discussed with parent/legal guardian during admissions. If the child and family require additional services after discharge, the behavioral health team will assist the family in the referral process.
                </p>
                <p className='w-750'>
                    <b>NOTICE: This entire document is reprinted in the Client Handbook which every client receives</b>
                </p>
                <p className='w-750'>
                    I understand the discharge policy explained to me upon admission to the above named program.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/ GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Positive Direction Support Services </h3>
                </p>
                <p className='w-750'>
                    <h3>Client Acknowledgement</h3>
                </p>
                <p className='w-750'>
                    I <input type='text' id='txtClientAcknowledgement' name='txtClientAcknowledgement' className='add-only w-200 custom-add-only' />   have discussed, understand and received a copy of the Client Handbook (Notice of Privacy Practices/Client Rights and Privacy, Member Responsibilities, Client Complaint, Client Abuse and Neglect, Client Acknowledgement of Crisis/Emergency Services), Client Contract, Release of Information Form, Freedom of Choice Form, and School Release letter (if applicable).</p>
                <p className='w-750'>
                    I understand and agree to participate in Behavioral Health services provided by this agency. I have been informed of alternatives and risks associated with the program. I further understand that my failure to follow the program's expectations regarding my responsibilities will result in the termination of those services provided to me by this agency.
                </p>
                <p className='w-750'>
                    l also understand that I have the right to change providers at anytime during the treatment process and have been given the phone number to contact Magellan Health Services to arrange for such transfer.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CLIENT NAME </td>
                        <td className='small w-375'> DATE OF BIRTH </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> PARENT/ GUARDIAN SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> STAFF SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Member Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Member DOB:</span> </td>
                        <td className='w-300'> <span className='eleHeader'> Member ID number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtMemberNameOne' name='txtMemberNameOne' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtMemberDateOfBirthOne' name='txtMemberDateOfBirthOne' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtMemberIdNumber' name='txtMemberIdNumber' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2>Healthy Louisiana Mental Health Rehabilitation Member Choice Form</h2>
                </p>
                <p className='w-750'>
                    <b>Member Information:</b>I am requesting services from a mental health rehabilitation (MHR) provider. I understand that I have the right to choose an agency to provide services to me or my child. I understand that I may only receive MHR services from one provider unless my health plan makes an exception. I may change provider if I am not satisfied with the services. <br />
                    If assistance is needed with finding an MHR Provider, review the list of providers located at your health plan's website below or call your plan for assistance.<br />
                    <ol>
                        <li className='w-700'>Aetna:<a href='https://www.aetnabetterhealth.com/louisiana/find-provider'>https://www.aetnabetterhealth.com/louisiana/find-provider</a>or call 1-855-242-0802 Hearing impaired
                            TTY/TDD 711</li>
                        <li className='w-700'>Amerihealth Caritas Louisiana:<a href='http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx'>http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx</a>or call
                            1-888-756-0004; TTY 1-866-428-7588</li>
                        <li className='w-700'>Healthy Blue:<a href='https://www.myhealthybluela.com/la/care/find-a-doctor.html'>https://www.myhealthybluela.com/la/care/find-a-doctor.html</a>or call 1-844-227-8350 (TTY 711)</li>
                        <li className='w-700'>Louisiana Healthcare Connections:<a href='https://providersearch.louisianahealthconnect.com/'> https://providersearch.louisianahealthconnect.com/</a>or call 1-866-595- 8133
                            (Hearing Loss: 711)</li>
                        <li className='w-700'>United Healthcare Community:<a href='http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html'>http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html</a>or call
                            1-866-675-1607 TTY: 1-877-4285-4514</li>
                    </ol>
                </p>
                <p className='w-750'>
                    The provider that I have freely selected to deliver MHR services to me or my child is :
                </p>

                <table>

                    <tr><td className='w-375'><span className='eleHeader'>Provider Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Provider Phone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtProviderName_1' name='txtProviderName_1' defaultValue='Positive Direction Support Services' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txtProviderPhone_2' name='txtProviderPhone_2' defaultValue='(504) 944-0453' className='add-only' /></td>
                    </tr>
                    <tr><td className='w-375'><span className='eleHeader'>Provider Contact Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtProviderContact_1' name='txtProviderContact_1' defaultValue='Donnyette J. Love, LCSW, BACS' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txtProviderAddress_2' name='txtProviderAddress_2' defaultValue='1995 Gentilly Blvd. Ste. C-400, New Orleans, LA 70119' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    By signing the form below, I understand that I have chosen to receive services from this MHR provider and I acknowledge that it is my responsibility to notify my previous provider so they can coordinate my care with my new provider. I understand that I am free to choose any MHR provider in my health plan's network.</p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>{`Member/Legal Guardina Signature`}</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>{`Printed Legal Guardian Name (if applicable)`}</td>
                    </tr>


                </table>
                <p className='w-750'>
                    <b>Provider Information:</b>A Member choice form is required proir to receiving any mental health rehabilitation services. This form requires member/legal guardian signature, date , identified provider with telephone and contact name. The provider is responsible for coordinating the transition of care with the member's previous provider prior to starting services.</p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Provider Signature</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>NICHQ Vanderbilt Assessment Scale-PARENT Informant</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Today's Date: </span>
                            <input type='date' id='txtTodayDate_1' name='txtTodayDate_1' className='add-only' />
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>Child's Name:</span>
                            <input type='text' id='txtChildsNameOne' name='txtChildsNameOne' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Birth:</span>
                            <input type='date' id='txtDateOfBirthParent' name='txtDateOfBirthParent' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent's Name:</span>
                            <input type='text' id='txtParentsName' name='txtParentsName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent's Phone Number:</span>
                            <input type='text' id='txtParentsPhoneNumber' name='txtParentsPhoneNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Directions: </strong> Each rating should be considered in the context of what is appropriate for the age of your child.
                    When completing this form, please think about your child's behaviors in the past 6 months.
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Is this evaluation based on a time when the child</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPredominantly_1' name='cbPredominantly_1' className='add-only' value='Predominantly' /> was on medication</td>
                        <td className='w-250'><input type='checkbox' id='cbPredominantly_2' name='cbPredominantly_2' className='add-only' value='Predominantly' /> was not on medication</td>
                        <td className='w-250'><input type='checkbox' id='cbPredominantly_3' name='cbPredominantly_3' className='add-only' value='Predominantly' /> notsure?</td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-400'><span className='eleHeader'>Symptoms</span></td>
                        <td className='w-75'><span className='eleHeader'>Never</span></td>
                        <td className=' w-100'><span className='eleHeader'>Occasionally</span></td>
                        <td className='w-75'><span className='eleHeader'>Often</span></td>
                        <td className=' w-100'><span className='eleHeader'>Very Often</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>1. Does not pay attention to details or makes careless mistakes with, for example, homework</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_13_1' name='rbNever_13' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_13_2' name='rbNever_13' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_13_3' name='rbNever_13' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_13_4' name='rbNever_13' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>2. Has difficulty keeping attention to what needs to be done</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_14_1' name='rbNever_14' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_14_2' name='rbNever_14' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_14_3' name='rbNever_14' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_14_4' name='rbNever_14' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>3. Does not seem to listen when spoken to directly</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_15_1' name='rbNever_15' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_15_2' name='rbNever_15' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_15_3' name='rbNever_15' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_15_4' name='rbNever_15' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>4. Does not follow through when given directions and fails to finish activities (not due to refusal or failure to understand)</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_16_1' name='rbNever_16' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_16_2' name='rbNever_16' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_16_3' name='rbNever_16' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_16_4' name='rbNever_16' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>5. Has difficulty organizing tasks and activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_17_1' name='rbNever_17' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_17_2' name='rbNever_17' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_17_3' name='rbNever_17' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_17_4' name='rbNever_17' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>6. Avoids, dislikes, or does not want to start tasks that require ongoing mental effort</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_18_1' name='rbNever_18' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_18_2' name='rbNever_18' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_18_3' name='rbNever_18' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_18_4' name='rbNever_18' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>7. Loses things necessary for tasks or activities (toys, assignments, pencils, or books)</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_19_1' name='rbNever_19' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_19_2' name='rbNever_19' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_19_3' name='rbNever_19' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_19_4' name='rbNever_19' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>8. Is easily distracted by noises or other stimuli</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_20_1' name='rbNever_20' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_20_2' name='rbNever_20' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_20_3' name='rbNever_20' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_20_4' name='rbNever_20' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>9. Is forgetful in daily activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_21_1' name='rbNever_21' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_21_2' name='rbNever_21' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_21_3' name='rbNever_21' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_21_4' name='rbNever_21' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>10. Fidgets with hands or feet or squirms in seat</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_22_1' name='rbNever_22' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_22_2' name='rbNever_22' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_22_3' name='rbNever_22' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_22_4' name='rbNever_22' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>11. Leaves seat when remaining seated is expected</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_23_1' name='rbNever_23' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_23_2' name='rbNever_23' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_23_3' name='rbNever_23' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_23_4' name='rbNever_23' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>12. Runs about or climbs too much when remaining seated is expected</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_24_1' name='rbNever_24' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_24_2' name='rbNever_24' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_24_3' name='rbNever_24' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_24_4' name='rbNever_24' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>13. Has difficulty playing or beginning quiet play activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_25_1' name='rbNever_25' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_25_2' name='rbNever_25' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_25_3' name='rbNever_25' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_25_4' name='rbNever_25' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>14. Is 'on the go' or often acts as if 'driven by a motor'</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_26_1' name='rbNever_26' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_26_2' name='rbNever_26' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_26_3' name='rbNever_26' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_26_4' name='rbNever_26' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>15. Talks too much</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_27_1' name='rbNever_27' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_27_2' name='rbNever_27' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_27_3' name='rbNever_27' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_27_4' name='rbNever_27' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>16. Blurts out answers before questions have been completed</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_28_1' name='rbNever_28' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_28_2' name='rbNever_28' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_28_3' name='rbNever_28' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_28_4' name='rbNever_28' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>17. Has difficulty waiting his or her turn</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_29_1' name='rbNever_29' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_29_2' name='rbNever_29' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_29_3' name='rbNever_29' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_29_4' name='rbNever_29' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>18. Interrupts or intrudes in on others' conversations and/or activities</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_30_1' name='rbNever_30' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_30_2' name='rbNever_30' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_30_3' name='rbNever_30' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_30_4' name='rbNever_30' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>19. Argues with adults</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_31_1' name='rbNever_31' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_31_2' name='rbNever_31' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_31_3' name='rbNever_31' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_31_4' name='rbNever_31' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>20. Loses temper</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_32_1' name='rbNever_32' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_32_2' name='rbNever_32' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_32_3' name='rbNever_32' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_32_4' name='rbNever_32' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>21. Actively defies or refuses to go along with adults' requests or rules</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_33_1' name='rbNever_33' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_33_2' name='rbNever_33' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_33_3' name='rbNever_33' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_33_4' name='rbNever_33' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>22. Deliberately annoys people</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_34_1' name='rbNever_34' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_34_2' name='rbNever_34' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_34_3' name='rbNever_34' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_34_4' name='rbNever_34' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>23. Blames others for his or her mistakes or misbehaviors</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_35_1' name='rbNever_35' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_35_2' name='rbNever_35' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_35_3' name='rbNever_35' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_35_4' name='rbNever_35' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>24. Is touchy or easily annoyed by others</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_36_1' name='rbNever_36' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_36_2' name='rbNever_36' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_36_3' name='rbNever_36' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_36_4' name='rbNever_36' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>25. Is angry or resentful</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_37_1' name='rbNever_37' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_37_2' name='rbNever_37' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_37_3' name='rbNever_37' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_37_4' name='rbNever_37' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>26. Is spiteful and wants to get even</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_38_1' name='rbNever_38' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_38_2' name='rbNever_38' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_38_3' name='rbNever_38' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_38_4' name='rbNever_38' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>27. Bullies, threatens, or intimidates others</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_39_1' name='rbNever_39' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_39_2' name='rbNever_39' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_39_3' name='rbNever_39' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_39_4' name='rbNever_39' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>28. Starts physical fights</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_40_1' name='rbNever_40' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_40_2' name='rbNever_40' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_40_3' name='rbNever_40' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_40_4' name='rbNever_40' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>29. Lies to get out of trouble or to avoid obligations (i.e., 'cons' others)</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_41_1' name='rbNever_41' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_41_2' name='rbNever_41' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_41_3' name='rbNever_41' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_41_4' name='rbNever_41' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>30. Is truant from school (skips school) without permission</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_42_1' name='rbNever_42' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_42_2' name='rbNever_42' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_42_3' name='rbNever_42' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_42_4' name='rbNever_42' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>31. Is physically cruel to people</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_43_1' name='rbNever_43' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_43_2' name='rbNever_43' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_43_3' name='rbNever_43' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_43_4' name='rbNever_43' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>32. Has stolen things that have value</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_44_1' name='rbNever_44' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_44_2' name='rbNever_44' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_44_3' name='rbNever_44' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_44_4' name='rbNever_44' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>33. Deliberately destroys others' property</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_45_1' name='rbNever_45' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_45_2' name='rbNever_45' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_45_3' name='rbNever_45' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_45_4' name='rbNever_45' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>34. Has used a weapon that can cause serious harm (bat, knife, brick,gun)</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_46_1' name='rbNever_46' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_46_2' name='rbNever_46' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_46_3' name='rbNever_46' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_46_4' name='rbNever_46' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>35. Is physically cruel to animals</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_47_1' name='rbNever_47' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_47_2' name='rbNever_47' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_47_3' name='rbNever_47' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_47_4' name='rbNever_47' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>36. Has deliberately set fires to cause damage</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_48_1' name='rbNever_48' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_48_2' name='rbNever_48' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_48_3' name='rbNever_48' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_48_4' name='rbNever_48' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>37. Has broken into someone else's home, business, or car</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_49_1' name='rbNever_49' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_49_2' name='rbNever_49' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_49_3' name='rbNever_49' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_49_4' name='rbNever_49' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>38. Has stayed out at night without permission</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_50_1' name='rbNever_50' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_50_2' name='rbNever_50' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_50_3' name='rbNever_50' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_50_4' name='rbNever_50' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>39. Has run away from home overnight</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_51_1' name='rbNever_51' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_51_2' name='rbNever_51' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_51_3' name='rbNever_51' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_51_4' name='rbNever_51' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>40. Has forced someone into sexual activity</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_52_1' name='rbNever_52' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_52_2' name='rbNever_52' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_52_3' name='rbNever_52' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_52_4' name='rbNever_52' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>41. Is fearful, anxious, or worried</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_53_1' name='rbNever_53' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_53_2' name='rbNever_53' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_53_3' name='rbNever_53' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_53_4' name='rbNever_53' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>42. Is afraid to try new things for fear of making mistakes</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_54_1' name='rbNever_54' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_54_2' name='rbNever_54' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_54_3' name='rbNever_54' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_54_4' name='rbNever_54' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>43. Feels worthless or inferior</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_55_1' name='rbNever_55' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_55_2' name='rbNever_55' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_55_3' name='rbNever_55' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_55_4' name='rbNever_55' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>44. Blames self for problems, feels guilty</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_56_1' name='rbNever_56' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_56_2' name='rbNever_56' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_56_3' name='rbNever_56' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_56_4' name='rbNever_56' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>45. Feels lonely, unwanted, or unloved; complains that 'no one loves him or her'</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_57_1' name='rbNever_57' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_57_2' name='rbNever_57' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_57_3' name='rbNever_57' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_57_4' name='rbNever_57' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>46. Is sad, unhappy, or depressed</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_58_1' name='rbNever_58' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_58_2' name='rbNever_58' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_58_3' name='rbNever_58' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_58_4' name='rbNever_58' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                    <tr>
                        <td className='w-400'>47. Is self-conscious or easily embarrassed</td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_59_1' name='rbNever_59' className='add-only' value='1' /> 0 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_59_2' name='rbNever_59' className='add-only' value='2' /> 1 </center></td>
                        <td className=' w-75'><center><input type='radio' id='rbNever_59_3' name='rbNever_59' className='add-only' value='3' /> 2 </center></td>
                        <td className=' w-100'><center><input type='radio' id='rbNever_59_4' name='rbNever_59' className='add-only' value='4' /> 3 </center></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Performance</span></td>
                        <td className='w-75'><span className='eleHeader'>Excellent</span></td>
                        <td className='w-100'><span className='eleHeader'>Above Average</span></td>
                        <td className='w-75'><span className='eleHeader'>Average</span></td>
                        <td className='w-150'><span className='eleHeader'>Somewhat of a Problem</span></td>
                        <td className='w-100'><span className='eleHeader'>Problematic</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>48. Overall School Performance</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_1_1' name='rbNever_1' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_1_2' name='rbNever_1' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_1_3' name='rbNever_1' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_1_4' name='rbNever_1' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_1_5' name='rbNever_1' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>49. Reading</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_2_1' name='rbNever_2' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_2_2' name='rbNever_2' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_2_3' name='rbNever_2' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_2_4' name='rbNever_2' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_2_5' name='rbNever_2' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>50. Writing</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_3_1' name='rbNever_3' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_3_2' name='rbNever_3' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_3_3' name='rbNever_3' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_3_4' name='rbNever_3' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_3_5' name='rbNever_3' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>51. Mathematics</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_4_1' name='rbNever_4' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_4_2' name='rbNever_4' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_4_3' name='rbNever_4' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_4_4' name='rbNever_4' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_4_5' name='rbNever_4' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>52. Relationship with parents</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_5_1' name='rbNever_5' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_5_2' name='rbNever_5' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_5_3' name='rbNever_5' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_5_4' name='rbNever_5' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_5_5' name='rbNever_5' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>53. Relationship with siblings</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_6_1' name='rbNever_6' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_6_2' name='rbNever_6' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_6_3' name='rbNever_6' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_6_4' name='rbNever_6' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_6_5' name='rbNever_6' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>54. Relationship with peers</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_7_1' name='rbNever_7' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_7_2' name='rbNever_7' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_7_3' name='rbNever_7' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_7_4' name='rbNever_7' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_7_5' name='rbNever_7' className='add-only' value='5' /> 5</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>55. Participation in organized activities (e.g., teams)</td>
                        <td className='w-75'><center><input type='radio' id='rbNever_8_1' name='rbNever_8' className='add-only' value='1' /> 1</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_8_2' name='rbNever_8' className='add-only' value='2' /> 2</center></td>
                        <td className='w-75'><center><input type='radio' id='rbNever_8_3' name='rbNever_8' className='add-only' value='3' /> 3</center></td>
                        <td className='w-150'><center><input type='radio' id='rbNever_8_4' name='rbNever_8' className='add-only' value='4' /> 4</center></td>
                        <td className='w-100'><center><input type='radio' id='rbNever_8_5' name='rbNever_8' className='add-only' value='5' /> 5</center></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_1' name='txtComments_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>For Office Use Only</span>
                </p>
                <table>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 1-9:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_1' name='txtTotalOne_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 10-18:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_2' name='txtTotalOne_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total Symptom Score for questions 1-18:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_3' name='txtTotalOne_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 19-26:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_4' name='txtTotalOne_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 27-40:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_5' name='txtTotalOne_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 2 or 3 in questions 41-47:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_6' name='txtTotalOne_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Total number of questions scored 4 or 5 in questions 48-55:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_7' name='txtTotalOne_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>Average Performance Score:</td>
                        <td className='w-150'><input type='text' id='txtTotalOne_8' name='txtTotalOne_8' className='add-only' /></td>
                    </tr>
                </table>








                <p className='w-750'><h5>Section Eight: Signatures</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <h4>MHR Agency Staff</h4>
                            <span className='small'>Check all that applies</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP1_1' id='cbMhrAgencyStaffP1_1' className='add-only' value='MhrAgencyStaff_1' />
                            1. The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to
                            collaborativelyidentify services.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP1_2' id='cbMhrAgencyStaffP1_2' className='add-only' value='MhrAgencyStaff_2' />
                            2. The treatment team certifies that the services requested; in this ISRP are based on an initial and ongoing assessment.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP1_3' id='cbMhrAgencyStaffP1_3' className='add-only' value='MhrAgencyStaff_3' />
                            3. The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and
                            comprehensive in approach.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP1_4' id='cbMhrAgencyStaffP1_4' className='add-only' value='MhrAgencyStaff_4' />
                            4. The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency
                            plan if any such plan(s) exist.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP1_5' id='cbMhrAgencyStaffP1_5' className='add-only' value='MhrAgencyStaff_5' />
                            5. The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation
                            services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <center><h4>Recipient/Natural Support</h4></center>
                            <span className='small'>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP1_1' id='cbRecipientNaturalSupportP1_1' className='add-only' value='RecipientNaturalSupport_1' />
                            1. I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below
                            in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which
                            reflects my goals and objectives.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP1_2' id='cbRecipientNaturalSupportP1_2' className='add-only' value='RecipientNaturalSupport_2' />
                            2. I freely choose to receive and participate in the Mental Health Rehabilitaflon services requested in the ISRP.
                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Recipient</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Parent/Guardian</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Primary LMHP</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Com. Support Worker</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Psychiatrist</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Other:</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><h5>Section Eight: Signatures</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <h4>MHR Agency Staff</h4>
                            <span className='small'>Check all that applies</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP2_1' id='cbMhrAgencyStaffP2_1' className='add-only' value='MhrAgencyStaff_1' />
                            1. The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to
                            collaborativelyidentify services.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP2_2' id='cbMhrAgencyStaffP2_2' className='add-only' value='MhrAgencyStaff_2' />
                            2. The treatment team certifies that the services requested; in this ISRP are based on an initial and ongoing assessment.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP2_3' id='cbMhrAgencyStaffP2_3' className='add-only' value='MhrAgencyStaff_3' />
                            3. The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and
                            comprehensive in approach.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP2_4' id='cbMhrAgencyStaffP2_4' className='add-only' value='MhrAgencyStaff_4' />
                            4. The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency
                            plan if any such plan(s) exist.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP2_5' id='cbMhrAgencyStaffP2_5' className='add-only' value='MhrAgencyStaff_5' />
                            5. The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation
                            services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <center><h4>Recipient/Natural Support</h4></center>
                            <span className='small'>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP2_1' id='cbRecipientNaturalSupportP2_1' className='add-only' value='RecipientNaturalSupport_1' />
                            1. I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below
                            in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which
                            reflects my goals and objectives.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP2_2' id='cbRecipientNaturalSupportP2_2' className='add-only' value='RecipientNaturalSupport_2' />
                            2. I freely choose to receive and participate in the Mental Health Rehabilitaflon services requested in the ISRP.
                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Recipient</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Parent/Guardian</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Primary LMHP</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Com. Support Worker</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Psychiatrist</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Other:</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><h5>Section Eight: Signatures</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <h4>MHR Agency Staff</h4>
                            <span className='small'>Check all that applies</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP3_1' id='cbMhrAgencyStaffP3_1' className='add-only' value='MhrAgencyStaff_1' />
                            1. The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to
                            collaborativelyidentify services.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP3_2' id='cbMhrAgencyStaffP3_2' className='add-only' value='MhrAgencyStaff_2' />
                            2. The treatment team certifies that the services requested; in this ISRP are based on an initial and ongoing assessment.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP3_3' id='cbMhrAgencyStaffP3_3' className='add-only' value='MhrAgencyStaff_3' />
                            3. The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and
                            comprehensive in approach.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP3_4' id='cbMhrAgencyStaffP3_4' className='add-only' value='MhrAgencyStaff_4' />
                            4. The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency
                            plan if any such plan(s) exist.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP3_5' id='cbMhrAgencyStaffP3_5' className='add-only' value='MhrAgencyStaff_5' />
                            5. The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation
                            services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <center><h4>Recipient/Natural Support</h4></center>
                            <span className='small'>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP3_1' id='cbRecipientNaturalSupportP3_1' className='add-only' value='RecipientNaturalSupport_1' />
                            1. I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below
                            in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which
                            reflects my goals and objectives.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP3_2' id='cbRecipientNaturalSupportP3_2' className='add-only' value='RecipientNaturalSupport_2' />
                            2. I freely choose to receive and participate in the Mental Health Rehabilitaflon services requested in the ISRP.
                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Recipient</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Parent/Guardian</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Primary LMHP</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Com. Support Worker</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Psychiatrist</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Other:</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><h5>Section Eight: Signatures</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <h4>MHR Agency Staff</h4>
                            <span className='small'>Check all that applies</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP4_1' id='cbMhrAgencyStaffP4_1' className='add-only' value='MhrAgencyStaff_1' />
                            1. The treatment team certifies that it met face-to-face with the recipient and/or caregiver or legal guardian to
                            collaborativelyidentify services.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP4_2' id='cbMhrAgencyStaffP4_2' className='add-only' value='MhrAgencyStaff_2' />
                            2. The treatment team certifies that the services requested; in this ISRP are based on an initial and ongoing assessment.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP4_3' id='cbMhrAgencyStaffP4_3' className='add-only' value='MhrAgencyStaff_3' />
                            3. The treatment team certifies that the services requested in this ISRP are medically necessary, appropriate, and
                            comprehensive in approach.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP4_4' id='cbMhrAgencyStaffP4_4' className='add-only' value='MhrAgencyStaff_4' />
                            4. The treatment team certifies that the ISRP is consistent with the recipient's ISC Plan, FINS Plan, and/or other interagency
                            plan if any such plan(s) exist.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbMhrAgencyStaffP4_5' id='cbMhrAgencyStaffP4_5' className='add-only' value='MhrAgencyStaff_5' />
                            5. The treatment team's professional opinion is that the recipient is ready to engage in the Mental Health Rehabilitation
                            services requested in this ISRP and it is reasonable to expect a rehabilitative outcome.
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <center><h4>Recipient/Natural Support</h4></center>
                            <span className='small'>Check all that applies. The parent/guardian and recipients over the age of 6 must sign the ISRP</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP4_1' id='cbRecipientNaturalSupportP4_1' className='add-only' value='RecipientNaturalSupport_1' />
                            1. I participated face-to-face with the psychiatrist and/or licensed mental health professional whose signature is below
                            in identifying my needs and in developing this Mental Health Rehabilitation Service Plan which
                            reflects my goals and objectives.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbRecipientNaturalSupportP4_2' id='cbRecipientNaturalSupportP4_2' className='add-only' value='RecipientNaturalSupport_2' />
                            2. I freely choose to receive and participate in the Mental Health Rehabilitaflon services requested in the ISRP.
                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Recipient</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Parent/Guardian</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Primary LMHP</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Com. Support Worker</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Psychiatrist</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Other:</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center>
                        <h3>CHILD & YOUTH MENTAL HEALTH GENERAL SCREENING QUESTIONNAIRE</h3>
                        <h4>Completed by Youth Aged 12 or Over </h4>
                    </center>
                    This information will assist your family practice team in providing the best possible care for you and your family.
                    Your answers will be kept strictly confidential as part of your medical record. <br />

                    Completing the questionnaire is voluntary and will not affect the health care you receive from your family practice team. <br />

                    If you have questions or want help filling this out, please ask a member of your
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name of Family Doctor:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByYouth_1' name='txtCompletedByYouth_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtCompletedByYouth_2' name='txtCompletedByYouth_2' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Your Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByYouth_3' name='txtCompletedByYouth_3' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>
                        Who currently lives in the family home? (List name(s) and relationship(s), for example, mother, brother, etc.)
                    </span>
                    <textarea name='txtCompletedByYouth_4' id='txtCompletedByYouth_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are you currently attending school</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCompletedByYouth_5_Yes' name='rbCompletedByYouth_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCompletedByYouth_5_No' name='rbCompletedByYouth_5' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of School:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Grade</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByYouth_6' name='txtCompletedByYouth_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByYouth_7' name='txtCompletedByYouth_7' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1. What are your reasons for talking with a counsellor?</span>
                            <span className='small'>(Check off all that apply)</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorSchoolProblems' name='cbReasonForTalkingToCounsellorSchoolProblems' className='add-only' value='SchoolProblems' /> School problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorFriendships' name='cbReasonForTalkingToCounsellorFriendships' className='add-only' value='Friendships' /> Friendships
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorFamily' name='cbReasonForTalkingToCounsellorFamily' className='add-only' value='Family' /> Family
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorBullyiongTeasing' name='cbReasonForTalkingToCounsellorBullyiongTeasing' className='add-only' value='BullyiongTeasing' /> Bullyiong or teasing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorFeelingDown' name='cbReasonForTalkingToCounsellorFeelingDown' className='add-only' value='FeelingDown' /> Feeling down or sad
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorFeelingWorriedStressed' name='cbReasonForTalkingToCounsellorFeelingWorriedStressed' className='add-only' value='FeelingWorriedStressed' /> Feeling worried or stressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorTemper' name='cbReasonForTalkingToCounsellorTemper' className='add-only' value='Temper' /> Temper
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorAlcoholDrugsGambling' name='cbReasonForTalkingToCounsellorAlcoholDrugsGambling' className='add-only' value='AlcoholDrugsGambling' /> Alcohol, drugs or gambling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorSleepingProblems' name='cbReasonForTalkingToCounsellorSleepingProblems' className='add-only' value='SleepingProblems' /> Sleeping problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorEatingBodyImage' name='cbReasonForTalkingToCounsellorEatingBodyImage' className='add-only' value='EatingBodyImage' /> Eating or body image
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReasonForTalkingToCounsellorOther' name='cbReasonForTalkingToCounsellorOther' className='add-only' value='ReasonForTalkingToCounsellorOther' /> Other (plese explain) &nbsp;
                            <input type='text' id='txt' name='txt' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. How long has this been a problem?</span>
                            <span className='small'>(circle one)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblemLessThan3Months' name='rbHowLongBeenProblem' className='add-only' value='LessThan3Months' /> Less than 3 months
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblem3To6Months' name='rbHowLongBeenProblem' className='add-only' value='3To6Months' /> 3 to 6 months
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblem6To12Months' name='rbHowLongBeenProblem' className='add-only' value='6To12Months' /> 6 to 12 months
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblem1To2Years' name='rbHowLongBeenProblem' className='add-only' value='1To2Years' /> 1 to 2 yrs
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>3. Because your privacy is important to us, do you have a cell phone pr alternative
                        number you would like us to call?
                    </span>
                    <input type='radio' id='rbAlternateNumber_Yes' name='rbAlternateNumber' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAlternateNumber_No' name='rbAlternateNumber' className='add-only' value='No' /> No <br />
                    <b>Number to call: </b>
                    <input type='text' id='txtAlternateNumberToCall' name='txtAlternateNumberToCall' className='add-only w-250 custom-add-only' /> <br />
                    Would you prefer we contact you on cell phone #
                    &nbsp; <input type='text' id='txtPreferToContactOnPhone' name='txtPreferToContactOnPhone' className='add-only w-250 custom-add-only' /> &nbsp; or by e-mail
                    &nbsp; <input type='text' id='txtPreferToContactOnPhone' name='txtPreferToContactOnPhone' className='add-only w-250 custom-add-only' /> ?
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Can we leave a message at your home number</span>
                    <input type='radio' id='rbMessageOnHomeNumber_Yes' name='rbMessageOnHomeNumber' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMessageOnHomeNumber_No' name='rbMessageOnHomeNumber' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Your Name</span></td>
                        <td className='w-187'><span className='eleHeader'>Gender</span></td>
                        <td className='w-187'><span className='eleHeader'>Age</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtYourName' name='txtYourName' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbYourGenderOne_Male' name='rbYourGenderOne' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbYourGenderOne_Female' name='rbYourGenderOne' className='add-only' value='Female' /> Female
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtYourAge' name='txtYourAge' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Birth:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Today's date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtYourDob' name='txtYourDob' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtTodayDate' name='txtTodayDate' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>
                        Below are examples of problems which people sometimes have.
                        Please circle whether each is NEVER true, SOMETIMES true, or OFTEN true of you.
                    </b>
                </p>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>1.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Easily distracted, have trouble sticking to activities
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_11_0' name='rbHealthGeneralByYouth_11' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_11_1' name='rbHealthGeneralByYouth_11' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_11_2' name='rbHealthGeneralByYouth_11' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Fail to finish things you start
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_12_0' name='rbHealthGeneralByYouth_12' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_12_1' name='rbHealthGeneralByYouth_12' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_12_2' name='rbHealthGeneralByYouth_12' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Have difficulty following directions or instructions
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_13_0' name='rbHealthGeneralByYouth_13' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_13_1' name='rbHealthGeneralByYouth_13' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_13_2' name='rbHealthGeneralByYouth_13' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Impulse, act without stopping to think
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_14_0' name='rbHealthGeneralByYouth_14' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_14_1' name='rbHealthGeneralByYouth_14' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_14_2' name='rbHealthGeneralByYouth_14' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Jump from one activity to another
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_15_0' name='rbHealthGeneralByYouth_15' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_15_1' name='rbHealthGeneralByYouth_15' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_15_2' name='rbHealthGeneralByYouth_15' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Fidget
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_16_0' name='rbHealthGeneralByYouth_16' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_16_1' name='rbHealthGeneralByYouth_16' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_16_2' name='rbHealthGeneralByYouth_16' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByYouth_1_Total' name='txtHealthGeneralByYouth_1_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>2.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Cranky
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_21_0' name='rbHealthGeneralByYouth_21' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_21_1' name='rbHealthGeneralByYouth_21' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_21_2' name='rbHealthGeneralByYouth_21' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Defiant, talk back to adults
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_22_0' name='rbHealthGeneralByYouth_22' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_22_1' name='rbHealthGeneralByYouth_22' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_22_2' name='rbHealthGeneralByYouth_22' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Blame others for your own mistakes
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_23_0' name='rbHealthGeneralByYouth_23' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_23_1' name='rbHealthGeneralByYouth_23' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_23_2' name='rbHealthGeneralByYouth_23' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Easily annoyed by others
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_24_0' name='rbHealthGeneralByYouth_24' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_24_1' name='rbHealthGeneralByYouth_24' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_24_2' name='rbHealthGeneralByYouth_24' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Argue a lot  with adults
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_25_0' name='rbHealthGeneralByYouth_25' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_25_1' name='rbHealthGeneralByYouth_25' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_25_2' name='rbHealthGeneralByYouth_25' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Angry and resentful
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_26_0' name='rbHealthGeneralByYouth_26' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_26_1' name='rbHealthGeneralByYouth_26' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_26_2' name='rbHealthGeneralByYouth_26' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByYouth_2_Total' name='txtHealthGeneralByYouth_2_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>3.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Steal things at home
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_31_0' name='rbHealthGeneralByYouth_31' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_31_1' name='rbHealthGeneralByYouth_31' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_31_2' name='rbHealthGeneralByYouth_31' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Destroy things belonging to others
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_32_0' name='rbHealthGeneralByYouth_32' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_32_1' name='rbHealthGeneralByYouth_32' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_32_2' name='rbHealthGeneralByYouth_32' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Damage school or other property
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_33_0' name='rbHealthGeneralByYouth_33' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_33_1' name='rbHealthGeneralByYouth_33' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_33_2' name='rbHealthGeneralByYouth_33' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Broken into someone else's house, building or car
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_34_0' name='rbHealthGeneralByYouth_34' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_34_1' name='rbHealthGeneralByYouth_34' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_34_2' name='rbHealthGeneralByYouth_34' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Physically attack people
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_35_0' name='rbHealthGeneralByYouth_35' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_35_1' name='rbHealthGeneralByYouth_35' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_35_2' name='rbHealthGeneralByYouth_35' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Use weapons when fighting
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_36_0' name='rbHealthGeneralByYouth_36' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_36_1' name='rbHealthGeneralByYouth_36' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_36_2' name='rbHealthGeneralByYouth_36' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByYouth_3_Total' name='txtHealthGeneralByYouth_3_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>4.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Worry something bad will happen to people you are close to
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_41_0' name='rbHealthGeneralByYouth_41' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_41_1' name='rbHealthGeneralByYouth_41' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_41_2' name='rbHealthGeneralByYouth_41' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worry about being separated from those you are close to
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_42_0' name='rbHealthGeneralByYouth_42' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_42_1' name='rbHealthGeneralByYouth_42' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_42_2' name='rbHealthGeneralByYouth_42' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Scared to go to sleep without parents nearby
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_43_0' name='rbHealthGeneralByYouth_43' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_43_1' name='rbHealthGeneralByYouth_43' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_43_2' name='rbHealthGeneralByYouth_43' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Overly upset when leaving someone you are close to
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_44_0' name='rbHealthGeneralByYouth_44' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_44_1' name='rbHealthGeneralByYouth_44' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_44_2' name='rbHealthGeneralByYouth_44' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Overly upset while away from someone you are close to
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_45_0' name='rbHealthGeneralByYouth_45' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_45_1' name='rbHealthGeneralByYouth_45' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_45_2' name='rbHealthGeneralByYouth_45' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Feel sick before being separated from those you are close to
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_46_0' name='rbHealthGeneralByYouth_46' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_46_1' name='rbHealthGeneralByYouth_46' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_46_2' name='rbHealthGeneralByYouth_46' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByYouth_4_Total' name='txtHealthGeneralByYouth_4_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>5.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Worry about doing better at things
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_51_0' name='rbHealthGeneralByYouth_51' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_51_1' name='rbHealthGeneralByYouth_51' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_51_2' name='rbHealthGeneralByYouth_51' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worry about past behaviour
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_52_0' name='rbHealthGeneralByYouth_52' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_52_1' name='rbHealthGeneralByYouth_52' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_52_2' name='rbHealthGeneralByYouth_52' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worry about doing the wrong thing
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_53_0' name='rbHealthGeneralByYouth_53' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_53_1' name='rbHealthGeneralByYouth_53' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_53_2' name='rbHealthGeneralByYouth_53' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worry about things in future
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_54_0' name='rbHealthGeneralByYouth_54' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_54_1' name='rbHealthGeneralByYouth_54' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_54_2' name='rbHealthGeneralByYouth_54' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Afraid of making mistakes
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_55_0' name='rbHealthGeneralByYouth_55' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_55_1' name='rbHealthGeneralByYouth_55' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_55_2' name='rbHealthGeneralByYouth_55' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Overly anxious to please people
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_56_0' name='rbHealthGeneralByYouth_56' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_56_1' name='rbHealthGeneralByYouth_56' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_56_2' name='rbHealthGeneralByYouth_56' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByYouth_5_Total' name='txtHealthGeneralByYouth_5_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>6.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            No interest in your usual activities
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_61_0' name='rbHealthGeneralByYouth_61' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_61_1' name='rbHealthGeneralByYouth_61' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_61_2' name='rbHealthGeneralByYouth_61' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Get no pleasure from your usual activities
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_62_0' name='rbHealthGeneralByYouth_62' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_62_1' name='rbHealthGeneralByYouth_62' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_62_2' name='rbHealthGeneralByYouth_62' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Trouble enjoying yourself
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_63_0' name='rbHealthGeneralByYouth_63' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_63_1' name='rbHealthGeneralByYouth_63' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_63_2' name='rbHealthGeneralByYouth_63' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Not as happy as other children
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_64_0' name='rbHealthGeneralByYouth_64' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_64_1' name='rbHealthGeneralByYouth_64' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_64_2' name='rbHealthGeneralByYouth_64' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Feel hopeless
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_65_0' name='rbHealthGeneralByYouth_65' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_65_1' name='rbHealthGeneralByYouth_65' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_65_2' name='rbHealthGeneralByYouth_65' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Unhappy, sad, or depressed
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_66_0' name='rbHealthGeneralByYouth_66' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_66_1' name='rbHealthGeneralByYouth_66' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByYouth_66_2' name='rbHealthGeneralByYouth_66' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByYouth_6_Total' name='txtHealthGeneralByYouth_6_Total' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <center>
                        <h3>CHILD & YOUTH MENTAL HEALTH GENERAL SCREENING QUESTIONNAIRE RECOMMENDATIONS</h3>
                    </center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Instructions for using the information from the Questionnaire: </span>

                    <ol>
                        <li>Review page 1 information provided by the parent/caregiver.</li>
                        <li>Score series of questions on page 2.</li>
                        <li>Add scores in each section.</li>
                    </ol>
                </p>

                <p className='w-750'><h4>Section 1:</h4>
                    The questions in this section relate to regulation of attention, impulsivity and activity.
                    A score above 7 is considered elevated relative to normed values for 6- to
                    18-year-olds. For screening tools and additional information about <b>ADHD</b>, see the <u>ADHD toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 2:</h4>
                    The questions in this section relate to oppositional/co-operative behaviour in relationships.
                    A score above 7 is considered elevated relative to normed values for 6- to 18-year-olds. For screening
                    tools and additional information about <b>Oppositional Defiant Disorder (ODD)</b>, see the <u>Behaviour Problems toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 3:</h4>
                    The questions in this section relate to conduct problems. A score above 0 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For screening tools and additional information about
                    <b> Conduct Disorder (CD)</b>, see the <u>Behaviour Problems toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 4:</h4>
                    The questions in this section relate to separation anxiety. A score above 6 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For screening tools and additional information about
                    <b> separation anxiety</b>, see the <u>Anxiety Disorders toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 5:</h4>
                    The questions in this section relate to managing anxiety. A score above 6 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For·screening tools and additional information about
                    <b> Generalized Anxiety Disorder</b>, see the <u>Anxiety Disorders toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 6:</h4>
                    The questions in this section relate to managing mood. A score above 5 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For screening tools and additional information
                    about <b>mood disorders</b>, see the <u>Mood Disorders toolkit</u>.
                </p>

                <p className='w-750'>
                    <i>The C&Y Mental Health General Screening Questionnaire is not a diagnostic tool. Although it
                        supports the identification of common mental health problems, it may miss some or
                        over-estimate others. The Questionnaire facilitates the communication of clinical
                        information when consulting with, or referring to, a mental health specialist. It should be interpreted
                        by a qualified mental health provider or physician with training in psychometric interpretation.
                    </i>
                </p>


                <p className='w-750'>
                    <center>
                        <h3>CHILD & YOUTH MENTAL HEALTH GENERAL SCREENING QUESTIONNAIRE</h3>
                        <h4>Completed by Caregiver </h4>
                    </center>
                    This information will assist your family practice team in providing the best possible care for you and your family.
                    Your answers will be kept strictly confidential as part of your child's, teen's and/or your medical record.
                    Completing the questionnaire is voluntary and will not affect the health care you receive from your family practice team. <br />

                    If you have questions or want help filling this out, please ask a member of your
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name of Family Doctor:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByCaregiver_1' name='txtCompletedByCaregiver_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtCompletedByCaregiver_2' name='txtCompletedByCaregiver_2' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Child's Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Name of person completing this form:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByCaregiver_ChildName' name='txtCompletedByCaregiver_ChildName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByCaregiver_PersonName' name='txtCompletedByCaregiver_PersonName' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>
                        Who currently lives in the family home? (List name(s) and relationship(s), for example, mother, brother, etc.)
                    </span>
                    <textarea name='txtCompletedByCaregiver_4' id='txtCompletedByCaregiver_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is he/she currently attending school</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCompletedByCaregiver_5_Yes' name='rbCompletedByCaregiver_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCompletedByCaregiver_5_No' name='rbCompletedByCaregiver_5' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of School:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Grade</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByCaregiver_6' name='txtCompletedByCaregiver_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCompletedByCaregiver_7' name='txtCompletedByCaregiver_7' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Whai is your main concern?</span>
                    <textarea name='txtCaregiverConcern' id='txtCaregiverConcern' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. How long has this been a problem?</span>
                            <span className='small'>(circle one)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblemCaregiverLessThan3Months' name='rbHowLongBeenProblemCaregiver' className='add-only' value='LessThan3Months' /> Less than 3 months
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblemCaregiver3To6Months' name='rbHowLongBeenProblemCaregiver' className='add-only' value='3To6Months' /> 3 to 6 months
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblemCaregiver6To12Months' name='rbHowLongBeenProblemCaregiver' className='add-only' value='6To12Months' /> 6 to 12 months
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHowLongBeenProblemCaregiver1To2Years' name='rbHowLongBeenProblemCaregiver' className='add-only' value='1To2Years' /> 1 to 2 yrs
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please circle any of the following that apply to you or your family:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverFinancialStressor' name='cbByCaregiverFinancialStressor' className='add-only' value='FinancialStressor' /> Financial stressor
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverAlcoholDrugUseParent' name='cbByCaregiverAlcoholDrugUseParent' className='add-only' value='AlcoholDrugUseParent' /> Alcohol or drug use (parent)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverSeparationDivorce' name='cbByCaregiverSeparationDivorce' className='add-only' value='SeparationDivorce' /> Separation/Divorce
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverDeathLovedOne' name='cbByCaregiverDeathLovedOne' className='add-only' value='DeathLovedOne' /> Death of loved one
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverAlcoholDrugUseChild' name='cbByCaregiverAlcoholDrugUseChild' className='add-only' value='AlcoholDrugUseChild' /> Alcohol or drug use (child/teen)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverCustodyAccess' name='cbByCaregiverCustodyAccess' className='add-only' value='CustodyAccess' /> Custody/Access dispute
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverFamilyViolence' name='cbByCaregiverFamilyViolence' className='add-only' value='FamilyViolence' /> Family violence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverMajorPhysicalIllnessParent' name='cbByCaregiverMajorPhysicalIllnessParent' className='add-only' value='MajorPhysicalIllnessParent' /> Major physical illness (parent)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverMovedHomes' name='cbByCaregiverMovedHomes' className='add-only' value='MovedHomes' /> Moved homes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverHistoryAbuseParent' name='cbByCaregiverHistoryAbuseParent' className='add-only' value='HistoryAbuseParent' /> History of abuse (parent)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverMajorPhysicalIllnessChild' name='cbByCaregiverMajorPhysicalIllnessChild' className='add-only' value='MajorPhysicalIllnessChild' /> Major physical illness (child)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverHistoryAbuseChild' name='cbByCaregiverHistoryAbuseChild' className='add-only' value='HistoryAbuseChild' /> History of abuse (child)
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>
                        What steps have you taken to deal with the problem at home, school, etc.?
                    </span>
                    <textarea name='txtByCaregiverProblemsAtHomeSchool' id='txtByCaregiverProblemsAtHomeSchool' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Have you received help in the past or currently for this problem?</span>
                            <span className='small'>(please check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverFamilyDoctor' name='cbByCaregiverFamilyDoctor' className='add-only' value='FamilyDoctor' /> Family Doctor
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverContactHamilton' name='cbByCaregiverContactHamilton' className='add-only' value='ContactHamilton' /> Contact Hamilton
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverCasCcas' name='cbByCaregiverCasCcas' className='add-only' value='CasCcas' /> CAS/CCAS
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverSchoolSupport' name='cbByCaregiverSchoolSupport' className='add-only' value='SchoolSupport' /> School Support
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbByCaregiverParentingGroup' name='cbByCaregiverParentingGroup' className='add-only' value='ParentingGroup' /> Parenting Group
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbByCaregiverOther' name='cbByCaregiverOther' className='add-only' value='Other' /> Other (Explain) &nbsp;
                            <input type='text' id='txtByCaregiverOther' name='txtByCaregiverOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Do you have any specific questions youi would like answered?</span>
                    <textarea name='txtByCaregiverSpecificQuestion' id='txtByCaregiverSpecificQuestion' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Is there anything else that would be helpful to share?</span>
                    <textarea name='txtByCaregiverHelpfulToShare' id='txtByCaregiverHelpfulToShare' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Your Name</span></td>
                        <td className='w-187'><span className='eleHeader'>Gender</span></td>
                        <td className='w-187'><span className='eleHeader'>Age</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtYourName' name='txtYourName' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbYourGender_Male' name='rbYourGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbYourGender_Female' name='rbYourGender' className='add-only' value='Female' /> Female
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtYourAge' name='txtYourAge' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Birth:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Today's date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtYourDob' name='txtYourDob' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtTodayDate' name='txtTodayDate' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>
                        Below are examples of problems which children sometimes have.
                        Please circle whether each is NEVER true, SOMETIMES true, or OFTEN true of this child.
                    </b>
                </p>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>1.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Distractible, has trouble sticking to an activity
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_11_0' name='rbHealthGeneralByCaregiver_11' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_11_1' name='rbHealthGeneralByCaregiver_11' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_11_2' name='rbHealthGeneralByCaregiver_11' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Fail to finish things he/she start
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_12_0' name='rbHealthGeneralByCaregiver_12' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_12_1' name='rbHealthGeneralByCaregiver_12' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_12_2' name='rbHealthGeneralByCaregiver_12' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Difficulty following directions or instructions
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_13_0' name='rbHealthGeneralByCaregiver_13' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_13_1' name='rbHealthGeneralByCaregiver_13' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_13_2' name='rbHealthGeneralByCaregiver_13' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Impulsive, acts without stopping to think
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_14_0' name='rbHealthGeneralByCaregiver_14' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_14_1' name='rbHealthGeneralByCaregiver_14' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_14_2' name='rbHealthGeneralByCaregiver_14' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Jumps from one activity to another
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_15_0' name='rbHealthGeneralByCaregiver_15' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_15_1' name='rbHealthGeneralByCaregiver_15' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_15_2' name='rbHealthGeneralByCaregiver_15' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Fidgets
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_16_0' name='rbHealthGeneralByCaregiver_16' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_16_1' name='rbHealthGeneralByCaregiver_16' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_16_2' name='rbHealthGeneralByCaregiver_16' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByCaregiver_1_Total' name='txtHealthGeneralByCaregiver_1_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>2.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Cranky
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_21_0' name='rbHealthGeneralByCaregiver_21' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_21_1' name='rbHealthGeneralByCaregiver_21' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_21_2' name='rbHealthGeneralByCaregiver_21' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Defiant, talks back to adults
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_22_0' name='rbHealthGeneralByCaregiver_22' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_22_1' name='rbHealthGeneralByCaregiver_22' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_22_2' name='rbHealthGeneralByCaregiver_22' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Blames others for his/her own mistakes
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_23_0' name='rbHealthGeneralByCaregiver_23' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_23_1' name='rbHealthGeneralByCaregiver_23' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_23_2' name='rbHealthGeneralByCaregiver_23' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Easily annoyed by others
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_24_0' name='rbHealthGeneralByCaregiver_24' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_24_1' name='rbHealthGeneralByCaregiver_24' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_24_2' name='rbHealthGeneralByCaregiver_24' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Argues a lot  with adults
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_25_0' name='rbHealthGeneralByCaregiver_25' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_25_1' name='rbHealthGeneralByCaregiver_25' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_25_2' name='rbHealthGeneralByCaregiver_25' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Angry and resentful
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_26_0' name='rbHealthGeneralByCaregiver_26' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_26_1' name='rbHealthGeneralByCaregiver_26' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_26_2' name='rbHealthGeneralByCaregiver_26' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByCaregiver_2_Total' name='txtHealthGeneralByCaregiver_2_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>3.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Steals things at home
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_31_0' name='rbHealthGeneralByCaregiver_31' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_31_1' name='rbHealthGeneralByCaregiver_31' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_31_2' name='rbHealthGeneralByCaregiver_31' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Destroys things belonging to others
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_32_0' name='rbHealthGeneralByCaregiver_32' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_32_1' name='rbHealthGeneralByCaregiver_32' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_32_2' name='rbHealthGeneralByCaregiver_32' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Engages in vandalism
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_33_0' name='rbHealthGeneralByCaregiver_33' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_33_1' name='rbHealthGeneralByCaregiver_33' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_33_2' name='rbHealthGeneralByCaregiver_33' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Broken into a house, building or car
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_34_0' name='rbHealthGeneralByCaregiver_34' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_34_1' name='rbHealthGeneralByCaregiver_34' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_34_2' name='rbHealthGeneralByCaregiver_34' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Physically attacks people
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_35_0' name='rbHealthGeneralByCaregiver_35' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_35_1' name='rbHealthGeneralByCaregiver_35' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_35_2' name='rbHealthGeneralByCaregiver_35' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Uses weapons when fighting
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_36_0' name='rbHealthGeneralByCaregiver_36' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_36_1' name='rbHealthGeneralByCaregiver_36' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_36_2' name='rbHealthGeneralByCaregiver_36' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByCaregiver_3_Total' name='txtHealthGeneralByCaregiver_3_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>4.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Worries about being separated from loved ones
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_41_0' name='rbHealthGeneralByCaregiver_41' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_41_1' name='rbHealthGeneralByCaregiver_41' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_41_2' name='rbHealthGeneralByCaregiver_41' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worry about things will happen to loved ones
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_42_0' name='rbHealthGeneralByCaregiver_42' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_42_1' name='rbHealthGeneralByCaregiver_42' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_42_2' name='rbHealthGeneralByCaregiver_42' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Scared to sleep without parents nearby
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_43_0' name='rbHealthGeneralByCaregiver_43' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_43_1' name='rbHealthGeneralByCaregiver_43' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_43_2' name='rbHealthGeneralByCaregiver_43' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Overly upset when leaving loved ones
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_44_0' name='rbHealthGeneralByCaregiver_44' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_44_1' name='rbHealthGeneralByCaregiver_44' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_44_2' name='rbHealthGeneralByCaregiver_44' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Overly upset while away from loved ones
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_45_0' name='rbHealthGeneralByCaregiver_45' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_45_1' name='rbHealthGeneralByCaregiver_45' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_45_2' name='rbHealthGeneralByCaregiver_45' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Complains of feeling sick before separating
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_46_0' name='rbHealthGeneralByCaregiver_46' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_46_1' name='rbHealthGeneralByCaregiver_46' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_46_2' name='rbHealthGeneralByCaregiver_46' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByCaregiver_4_Total' name='txtHealthGeneralByCaregiver_4_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>5.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            Worries about doing better at things
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_51_0' name='rbHealthGeneralByCaregiver_51' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_51_1' name='rbHealthGeneralByCaregiver_51' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_51_2' name='rbHealthGeneralByCaregiver_51' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worries about past behaviour
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_52_0' name='rbHealthGeneralByCaregiver_52' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_52_1' name='rbHealthGeneralByCaregiver_52' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_52_2' name='rbHealthGeneralByCaregiver_52' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worries about doing the wrong thing
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_53_0' name='rbHealthGeneralByCaregiver_53' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_53_1' name='rbHealthGeneralByCaregiver_53' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_53_2' name='rbHealthGeneralByCaregiver_53' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Worries about things in future
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_54_0' name='rbHealthGeneralByCaregiver_54' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_54_1' name='rbHealthGeneralByCaregiver_54' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_54_2' name='rbHealthGeneralByCaregiver_54' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Afraid of making mistakes
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_55_0' name='rbHealthGeneralByCaregiver_55' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_55_1' name='rbHealthGeneralByCaregiver_55' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_55_2' name='rbHealthGeneralByCaregiver_55' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Overly anxious to please people
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_56_0' name='rbHealthGeneralByCaregiver_56' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_56_1' name='rbHealthGeneralByCaregiver_56' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_56_2' name='rbHealthGeneralByCaregiver_56' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByCaregiver_5_Total' name='txtHealthGeneralByCaregiver_5_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>6.</span>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>never</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>sometimes</span></center>
                        </td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>often</span></center>
                        </td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>
                            No interest in your usual activities
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_61_0' name='rbHealthGeneralByCaregiver_61' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_61_1' name='rbHealthGeneralByCaregiver_61' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_61_2' name='rbHealthGeneralByCaregiver_61' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Gets no pleasure from your usual activities
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_62_0' name='rbHealthGeneralByCaregiver_62' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_62_1' name='rbHealthGeneralByCaregiver_62' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_62_2' name='rbHealthGeneralByCaregiver_62' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Trouble enjoying him/her self
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_63_0' name='rbHealthGeneralByCaregiver_63' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_63_1' name='rbHealthGeneralByCaregiver_63' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_63_2' name='rbHealthGeneralByCaregiver_63' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Not as happy as other children
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_64_0' name='rbHealthGeneralByCaregiver_64' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_64_1' name='rbHealthGeneralByCaregiver_64' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_64_2' name='rbHealthGeneralByCaregiver_64' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            Feels hopeless
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_65_0' name='rbHealthGeneralByCaregiver_65' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_65_1' name='rbHealthGeneralByCaregiver_65' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_65_2' name='rbHealthGeneralByCaregiver_65' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            seems unhappy, sad, or depressed
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_66_0' name='rbHealthGeneralByCaregiver_66' className='add-only' value='0' /> 0 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_66_1' name='rbHealthGeneralByCaregiver_66' className='add-only' value='1' /> 1 </center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHealthGeneralByCaregiver_66_2' name='rbHealthGeneralByCaregiver_66' className='add-only' value='2' /> 2 </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>&nbsp;</td>
                        <td className='w-50'><b>Total: </b></td>
                        <td className='w-300'>
                            <input type='text' id='txtHealthGeneralByCaregiver_6_Total' name='txtHealthGeneralByCaregiver_6_Total' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center>
                        <h3>CHILD & YOUTH MENTAL HEALTH GENERAL SCREENING QUESTIONNAIRE RECOMMENDATIONS</h3>
                    </center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Instructions for using the information from the Questionnaire: </span>

                    <ol>
                        <li>Review page 1 information provided by the parent/caregiver.</li>
                        <li>Score series of questions on page 2.</li>
                        <li>Add scores in each section.</li>
                    </ol>
                </p>

                <p className='w-750'><h4>Section 1:</h4>
                    The questions in this section relate to regulation of attention, impulsivity and activity.
                    A score above 7 is considered elevated relative to normed values for 6- to
                    18-year-olds. For screening tools and additional information about <b>ADHD</b>, see the <u>ADHD toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 2:</h4>
                    The questions in this section relate to oppositional/co-operative behaviour in relationships.
                    A score above 7 is considered elevated relative to normed values for 6- to 18-year-olds. For screening
                    tools and additional information about <b>Oppositional Defiant Disorder (ODD)</b>, see the <u>Behaviour Problems toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 3:</h4>
                    The questions in this section relate to conduct problems. A score above 0 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For screening tools and additional information about
                    <b> Conduct Disorder (CD)</b>, see the <u>Behaviour Problems toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 4:</h4>
                    The questions in this section relate to separation anxiety. A score above 6 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For screening tools and additional information about
                    <b> separation anxiety</b>, see the <u>Anxiety Disorders toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 5:</h4>
                    The questions in this section relate to managing anxiety. A score above 6 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For·screening tools and additional information about
                    <b> Generalized Anxiety Disorder</b>, see the <u>Anxiety Disorders toolkit</u>.
                </p>

                <p className='w-750'><h4>Section 6:</h4>
                    The questions in this section relate to managing mood. A score above 5 is considered elevated
                    relative to normed values for 6- to 18-year-olds. For screening tools and additional information
                    about <b>mood disorders</b>, see the <u>Mood Disorders toolkit</u>.
                </p>

                <p className='w-750'>
                    <i>The C&Y Mental Health General Screening Questionnaire is not a diagnostic tool. Although it
                        supports the identification of common mental health problems, it may miss some or
                        over-estimate others. The Questionnaire facilitates the communication of clinical
                        information when consulting with, or referring to, a mental health specialist. It should be interpreted
                        by a qualified mental health provider or physician with training in psychometric interpretation.
                    </i>
                </p>

            </div>
        </form >
    )
}